import React, { useState, useEffect, useCallback } from "react";
import cache from "./utils/cache";
import SettingsModal from "./components/SettingsModal";

console.log('[INIT] Capacitor HTTP plugin imported');

// Countries with flag emojis and phone country codes for UI display (fresh build trigger)

// ===== API CONFIGURATION =====
// Determine API base URL based on environment
// IMPORTANT: Check Capacitor FIRST before checking production mode
// because `npm run build` sets NODE_ENV=production for the bundle
// Port mapping: 8001 (FastAPI backend - main), 8000 (general domain), 8011 (ML service)
const isCapacitor = typeof window.Capacitor !== 'undefined';
const isProduction = process.env.NODE_ENV === 'production' && !isCapacitor;

let API_BASE_URL;
if (isCapacitor) {
  // For iOS/Android simulator: use 127.0.0.1 which maps to host machine
  API_BASE_URL = 'http://127.0.0.1:8001';
} else if (process.env.NODE_ENV === 'development') {
  // For local development: use FastAPI backend (port 8001)
  API_BASE_URL = process.env.REACT_APP_API_BASE || 'http://localhost:8001';
} else {
  // For production: use AWS backend directly
  // Note: This will trigger mixed content warnings in HTTPS environment
  // For production deployment, backend needs HTTPS enabled
  API_BASE_URL = process.env.REACT_APP_API_BASE || 'http://34.205.140.60';
}

console.log('[APP] NODE_ENV:', process.env.NODE_ENV);
console.log('[APP] isCapacitor:', isCapacitor);
console.log('[APP] isProduction:', isProduction);
console.log('[APP] API Base URL:', API_BASE_URL);
console.log('[APP] Window location:', window.location.href);
console.log('[APP] Backend ports: 8001 (FastAPI), 8011 (ML), 8000 (general domain - future)');

const COUNTRIES = [
  { code: 'US', name: 'United States', flag: '🇺🇸', phoneCode: '+1' },
  { code: 'UK', name: 'United Kingdom', flag: '🇬🇧', phoneCode: '+44' },
  { code: 'NG', name: 'Nigeria', flag: '🇳🇬', phoneCode: '+234' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦', phoneCode: '+1' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺', phoneCode: '+61' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪', phoneCode: '+49' },
  { code: 'FR', name: 'France', flag: '🇫🇷', phoneCode: '+33' },
  { code: 'IT', name: 'Italy', flag: '🇮🇹', phoneCode: '+39' },
  { code: 'ES', name: 'Spain', flag: '🇪🇸', phoneCode: '+34' },
  { code: 'NL', name: 'Netherlands', flag: '🇳🇱', phoneCode: '+31' },
  { code: 'BE', name: 'Belgium', flag: '🇧🇪', phoneCode: '+32' },
  { code: 'CH', name: 'Switzerland', flag: '🇨🇭', phoneCode: '+41' },
  { code: 'SE', name: 'Sweden', flag: '🇸🇪', phoneCode: '+46' },
  { code: 'NO', name: 'Norway', flag: '🇳🇴', phoneCode: '+47' },
  { code: 'DK', name: 'Denmark', flag: '🇩🇰', phoneCode: '+45' },
  { code: 'PL', name: 'Poland', flag: '🇵🇱', phoneCode: '+48' },
  { code: 'JP', name: 'Japan', flag: '🇯🇵', phoneCode: '+81' },
  { code: 'CN', name: 'China', flag: '🇨🇳', phoneCode: '+86' },
  { code: 'IN', name: 'India', flag: '🇮🇳', phoneCode: '+91' },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬', phoneCode: '+65' },
  { code: 'MY', name: 'Malaysia', flag: '🇲🇾', phoneCode: '+60' },
  { code: 'TH', name: 'Thailand', flag: '🇹🇭', phoneCode: '+66' },
  { code: 'PH', name: 'Philippines', flag: '🇵🇭', phoneCode: '+63' },
  { code: 'ZA', name: 'South Africa', flag: '🇿🇦', phoneCode: '+27' },
  { code: 'EG', name: 'Egypt', flag: '🇪🇬', phoneCode: '+20' },
  { code: 'KE', name: 'Kenya', flag: '🇰🇪', phoneCode: '+254' },
  { code: 'GH', name: 'Ghana', flag: '🇬🇭', phoneCode: '+233' },
];

const PUZZLES = [
  { q: "What has keys but can't open locks?", a: "A piano" },
  { q: "What has a heart that doesn’t beat?", a: "An artichoke" },
  { q: "What comes once in a minute, twice in a moment, but never in a thousand years?", a: "The letter M" },
  { q: "What can travel around the world while staying in a corner?", a: "A stamp" },
  { q: "What gets wetter as it dries?", a: "A towel" },
  { q: "What has a neck but no head?", a: "A bottle" },
  { q: "What belongs to you but others use it more than you do?", a: "Your name" },
  { q: "What has hands but can’t clap?", a: "A clock" },
  { q: "What can you catch but not throw?", a: "A cold" },
  { q: "What has an eye but cannot see?", a: "A needle" },
  { q: "What is always in front of you but can’t be seen?", a: "The future" },
  { q: "What goes up but never comes down?", a: "Your age" },
  { q: "What has one head, one foot, and four legs?", a: "A bed" },
  { q: "What gets bigger the more you take away?", a: "A hole" },
  { q: "What has many teeth but can’t bite?", a: "A comb" },
  { q: "What runs but never walks?", a: "Water" },
  { q: "What can fill a room but takes up no space?", a: "Light" },
  { q: "What kind of band never plays music?", a: "A rubber band" },
  { q: "What has a thumb and four fingers but is not alive?", a: "A glove" },
  { q: "What has words but never speaks?", a: "A book" },
  { q: "What has a bottom at the top?", a: "Your legs" },
];

function getRandomPuzzleIdx(excludeIdx) {
  let idx;
  do {
    idx = Math.floor(Math.random() * PUZZLES.length);
  } while (idx === excludeIdx);
  return idx;
}

function App() {
  // Removed unused: toast, showToast, authAddress, files, editMode
  // Removed unused: toast, showToast, authAddress, files, editMode
  // Removed unused: toast, showToast, authAddress, files, editMode
  // Removed unused: toast, showToast, authAddress, files, editMode
  const [errands, setErrands] = useState([]);
  const [detailsModal, setDetailsModal] = useState({ open: false, errand: null });
  const [uploadedFiles, setUploadedFiles] = useState([]); // For transparency
  const [selectedErrands, setSelectedErrands] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [expandedErrandId, setExpandedErrandId] = useState(null); // For collapsible rows
  const [errandsSectionMinimized, setErrandsSectionMinimized] = useState(false); // For minimize/maximize
  const [isRefreshing, setIsRefreshing] = useState(false); // Visual indicator for refresh
  const [previousErrands, setPreviousErrands] = useState([]); // Track previous state for change detection
  const [notification, setNotification] = useState(null); // { message, type: 'approved'|'updated' }
  
  // Delete a single errand by ID
  async function handleDeleteErrand(id) {
    // Show confirmation dialog
    const confirmDelete = window.confirm('Are you sure you want to delete this errand? This action cannot be undone.');
    if (!confirmDelete) return;
    
    try {
      // Try multiple ways to get the token
      let token = localStorage.getItem('authToken');
      if (!token) {
        token = cache.getAuthToken();
        console.log(`[DELETE] Token from cache: ${token ? token.substring(0, 30) + '...' : 'NONE'}`);
      } else {
        console.log(`[DELETE] Token from localStorage: ${token.substring(0, 30)}...`);
      }
      
      const headers = { 'Content-Type': 'application/json' };
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
        console.log(`[DELETE] Errand ${id} - Using auth token: ${token.substring(0, 30)}...`);
      } else {
        console.warn(`[DELETE] Errand ${id} - NO AUTH TOKEN FOUND!`);
        alert('You must be logged in to delete errands');
        return;
      }
      
      console.log(`[DELETE] API_BASE_URL: ${API_BASE_URL}`);
      console.log(`[DELETE] Sending delete mutation for errand ${id}`);
      const mutation = `mutation DeleteErrand($id: Int!) { deleteErrand(id: $id) }`;
      
      const response = await fetch(`${API_BASE_URL}/graphql`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ query: mutation, variables: { id } })
      });
      
      const responseText = await response.text();
      console.log(`[DELETE] Response status: ${response.status}`);
      console.log(`[DELETE] Response text: ${responseText}`);
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (parseErr) {
        console.error(`[DELETE] Failed to parse response as JSON:`, parseErr);
        alert(`Failed to delete errand: Invalid response from server (${response.status})`);
        return;
      }
      
      console.log(`[DELETE] Full response:`, JSON.stringify(data, null, 2));
      console.log(`[DELETE] data.data:`, data.data);
      console.log(`[DELETE] data.data?.deleteErrand:`, data.data?.deleteErrand);
      
      if (data.errors) {
        console.error(`[DELETE] GraphQL error:`, data.errors);
        const errorMsg = data.errors[0]?.message || 'Unknown error';
        alert(`Failed to delete errand: ${errorMsg}`);
        return;
      }
      
      // Check if deletion was successful
      if (!data.data || data.data.deleteErrand !== true) {
        console.error(`[DELETE] Deletion failed - response was not true:`, data.data?.deleteErrand);
        alert('Failed to delete errand. Please try again.');
        return;
      }
      
      console.log(`[DELETE] ✅ Errand ${id} deleted successfully`);
      alert('Errand deleted successfully');
      // Immediately remove from UI
      setErrands(prevErrands => prevErrands.filter(e => e.id !== id));
      // Fetch fresh data without clearing auth cache
      await fetchErrands(true);
    } catch (err) {
      console.error('[DELETE] Network error:', err);
      alert('Failed to delete errand. Please try again.');
    }
  }

  // Delete all selected errands
  async function handleDeleteSelected() {
    if (selectedErrands.length === 0) {
      alert('Please select at least one errand to delete');
      return;
    }
    
    const confirmDelete = window.confirm(`Are you sure you want to delete ${selectedErrands.length} errand(s)? This action cannot be undone.`);
    if (!confirmDelete) return;
    
    console.log(`[DELETE] Deleting ${selectedErrands.length} selected errands:`, selectedErrands);
    let successCount = 0;
    let failureCount = 0;
    
    for (const id of selectedErrands) {
      try {
        const token = localStorage.getItem('authToken');
        const headers = { 'Content-Type': 'application/json' };
        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }
        
        const mutation = `mutation DeleteErrand($id: Int!) { deleteErrand(id: $id) }`;
        const response = await fetch(`${API_BASE_URL}/graphql`, {
          method: 'POST',
          headers,
          body: JSON.stringify({ query: mutation, variables: { id } })
        });
        
        const data = await response.json();
        
        if (data.data && data.data.deleteErrand === true) {
          console.log(`[DELETE] ✅ Errand ${id} deleted successfully`);
          successCount++;
        } else if (data.errors) {
          console.error(`[DELETE] ❌ Failed to delete errand ${id}:`, data.errors);
          failureCount++;
        }
      } catch (err) {
        console.error(`[DELETE] Network error for errand ${id}:`, err);
        failureCount++;
      }
    }
    
    const message = failureCount === 0 
      ? `✅ Successfully deleted ${successCount} errand(s)`
      : `⚠️ Deleted ${successCount} errand(s), failed to delete ${failureCount}`;
    
    console.log(`[DELETE] ${message}`);
    alert(message);
    
    // Immediately remove deleted errands from UI
    setErrands(prevErrands => prevErrands.filter(e => !selectedErrands.includes(e.id)));
    setSelectedErrands([]);
    setSelectAll(false);
    // Fetch fresh data without clearing auth cache
    await fetchErrands(true);
  }

  // Handle edit errand
  function handleEditErrand(errand) {
    setEditingErrand(errand);
    setEditFormData({
      title: errand.title,
      note: errand.note,
      sensitivity: errand.sensitivity,
      pickupLocation: errand.pickupLocation,
      dropoffLocation: errand.dropoffLocation,
      template: errand.template || 'Official Document / Office Pickup'
    });
    setEditModalOpen(true);
  }

  function handleSaveEdit() {
    if (!editingErrand) return;
    
    const mutation = `
      mutation UpdateErrand($id: Int!, $title: String, $description: String, $templateId: String, $sensitivity: String, $pickupLocation: String, $dropoffLocation: String, $note: String) {
        updateErrand(input: { id: $id, title: $title, description: $description, templateId: $templateId, sensitivity: $sensitivity, pickupLocation: $pickupLocation, dropoffLocation: $dropoffLocation, note: $note }) {
          id
          title
          description
          templateId
          sensitivity
          pickupLocation
          dropoffLocation
          note
          status
        }
      }
    `;

    const token = localStorage.getItem('authToken');
    if (!token) {
      alert('❌ Error: Not logged in. Please log in first.');
      return;
    }

    fetch(`${API_BASE_URL}/graphql`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        query: mutation,
        variables: {
          id: editingErrand.id,
          title: editFormData.title,
          description: editFormData.note,
          templateId: editFormData.template,
          sensitivity: editFormData.sensitivity,
          pickupLocation: editFormData.pickupLocation,
          dropoffLocation: editFormData.dropoffLocation,
          note: editFormData.note
        }
      })
    })
    .then(res => res.json())
    .then(data => {
      if (data.errors) {
        alert('❌ Error updating errand:\n' + data.errors.map(e => e.message).join('\n'));
        console.error('GraphQL errors:', data.errors);
      } else if (data.data && data.data.updateErrand) {
        setAiError('✅ Errand updated successfully!');
        setTimeout(() => setAiError(''), 3000);
        fetchErrands(); // Refresh the errands list
        setEditModalOpen(false);
        setEditingErrand(null);
      }
    })
    .catch(err => {
      alert('❌ Error: ' + err.message);
      console.error('Fetch error:', err);
    });
  }

  // Handle assign errand to admin
  async function handleAssignErrand(errandId) {
    try {
      const token = localStorage.getItem('authToken') || cache.getAuthToken();
      if (!token) {
        alert('❌ Not authenticated');
        return;
      }
      
      // Optimistic update: update local state immediately
      setAdminErrandsList(prev => 
        prev.map(e => e.id === errandId ? { ...e, status: 'assigned' } : e)
      );
      
      const response = await fetch(`${API_BASE_URL}/admin/errands/${errandId}/status`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ status: 'assigned' })
      });
      
      const data = await response.json();
      if (!response.ok) {
        alert(`❌ Error assigning errand: ${data.detail || 'Unknown error'}`);
        loadAdminData(); // Revert optimistic update on error
        return;
      }

      alert('✅ Errand assigned successfully!');
      loadAdminData();
    } catch (err) {
      console.error('Error assigning errand:', err);
      alert('❌ Failed to assign errand. Please try again.');
      loadAdminData(); // Refresh on error
    }
  }

  // Handle mark errand as done
  async function handleMarkDone(errandId) {
    const confirmDone = window.confirm('Mark this errand as completed?');
    if (!confirmDone) return;
    
    const mutation = `mutation { markErrandDone(errandId: ${errandId}) { id status reviewStatus } }`;
    try {
      const token = localStorage.getItem('authToken') || cache.getAuthToken();
      if (!token) {
        alert('Not authenticated');
        return;
      }
      
      const response = await fetch(`${API_BASE_URL}/graphql`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ query: mutation })
      });
      
      const data = await response.json();
      if (data.errors) {
        alert(`Error marking errand as done: ${data.errors[0]?.message || 'Unknown error'}`);
        return;
      }
      
      if (data.data && data.data.markErrandDone) {
        alert('✅ Errand marked as completed!');
        
        // If current user is the customer, open review modal
        const errand = errands.find(e => e.id === errandId);
        if (errand && errand.userId === parseInt(localStorage.getItem('userId'))) {
          setReviewErrand(data.data.markErrandDone);
          setReviewModalOpen(true);
          setReviewRating(5);
          setReviewNotes('');
        }
        
        fetchErrands();
      }
    } catch (err) {
      console.error('Error marking errand as done:', err);
      alert('Failed to mark errand as done. Please try again.');
    }
  }

  // Handle submit review
  async function handleSubmitReview() {
    if (!reviewErrand) return;
    
    setReviewSubmitting(true);
    const mutation = `
      mutation {
        submitErrandReview(errandId: ${reviewErrand.id}, rating: ${reviewRating}, notes: "${reviewNotes.replace(/"/g, '\\"')}")  {
          id reviewStatus reviewerRating reviewCompletedAt
        }
      }
    `;
    
    try {
      const token = localStorage.getItem('authToken') || cache.getAuthToken();
      if (!token) {
        alert('Not authenticated');
        setReviewSubmitting(false);
        return;
      }
      
      const response = await fetch(`${API_BASE_URL}/graphql`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ query: mutation })
      });
      
      const data = await response.json();
      if (data.errors) {
        alert(`Error submitting review: ${data.errors[0]?.message || 'Unknown error'}`);
        setReviewSubmitting(false);
        return;
      }
      
      if (data.data && data.data.submitErrandReview) {
        alert('✅ Thank you for your review!');
        setReviewModalOpen(false);
        setReviewErrand(null);
        setReviewRating(5);
        setReviewNotes('');
        fetchErrands();
      }
      setReviewSubmitting(false);
    } catch (err) {
      console.error('Error submitting review:', err);
      alert('Failed to submit review. Please try again.');
      setReviewSubmitting(false);
    }
  }

  // Handle select all toggle
  function handleSelectAll(e) {
    const checked = e.target.checked;
    setSelectAll(checked);
    if (checked) {
      setSelectedErrands(errands.map(e => e.id));
    } else {
      setSelectedErrands([]);
    }
  }

  // Handle individual checkbox toggle
  function handleSelectErrand(id) {
    setSelectedErrands(prev =>
      prev.includes(id) ? prev.filter(eid => eid !== id) : [...prev, id]
    );
  }
  // Removed unused: toast, showToast, authAddress, files, editMode

  // Fetch errands on load and after submit
  async function fetchErrands(skipCache = false) {
    const query = `query { errands { id referenceNumber title status pickupLocation dropoffLocation sensitivity createdAt note pickupTimeSlotDate pickupTimeSlotStart pickupTimeSlotEnd attachments { id filename contentType sizeBytes createdAt } history { eventType oldStatus newStatus createdAt userId } } }`;
    try {
      // Check cache first - returns null if expired or missing
      const cachedErrands = skipCache ? null : await cache.getAPIResponse('errands_list');
      if (cachedErrands) {
        console.log('[FETCH_ERRANDS] Using cached errands list (from 2-minute cache)');
        setErrands(cachedErrands);
        const allFiles = cachedErrands.flatMap(e => (e.attachments || []));
        setUploadedFiles(allFiles);
        // Still fetch fresh data in background without blocking UI
        // This gives user instant results while updating data
      } else {
        console.log('[FETCH_ERRANDS] Cache miss, fetching fresh data from server');
      }
      
      const token = localStorage.getItem('authToken') || cache.getAuthToken();
      console.log('[FETCH_ERRANDS] Token from cache/localStorage:', token ? `${token.substring(0, 50)}...` : 'NO TOKEN FOUND');
      console.log('[FETCH_ERRANDS] All localStorage keys:', Object.keys(localStorage));
      
      const headers = { 'Content-Type': 'application/json' };
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
        console.log('[FETCH_ERRANDS] Authorization header set');
      } else {
        console.log('[FETCH_ERRANDS] ⚠️ NO TOKEN - Sending request WITHOUT auth header');
      }
      
      console.log('[FETCH_ERRANDS] Sending GraphQL query to', API_BASE_URL + '/graphql');
      console.log('[FETCH_ERRANDS] Headers:', headers);
      
      const res = await fetch(`${API_BASE_URL}/graphql`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ query })
      });
      
      const data = await res.json();
      console.log('[FETCH_ERRANDS] GraphQL response status:', res.status);
      console.log('[FETCH_ERRANDS] GraphQL response data:', data);
      
      if (data.data && data.data.errands) {
        console.log(`[FETCH_ERRANDS] ✅ Got ${data.data.errands.length} errand(s)`);
        
        // Detect changes in errand statuses for notifications
        if (previousErrands && previousErrands.length > 0) {
          data.data.errands.forEach(newErrand => {
            const oldErrand = previousErrands.find(e => e.id === newErrand.id);
            if (oldErrand && oldErrand.status !== newErrand.status) {
              console.log(`[CHANGE DETECTED] Errand ${newErrand.id}: ${oldErrand.status} → ${newErrand.status}`);
              
              // Show notification for specific status changes
              if (newErrand.status === 'completed') {
                console.log(`[NOTIFICATION] Errand approved/completed: "${newErrand.title}"`);
                setNotification({
                  message: `✅ Errand approved: "${newErrand.title}" - Click to accept!`,
                  errandId: newErrand.id,
                  type: 'approved'
                });
                
                // Auto-dismiss notification after 10 seconds
                setTimeout(() => setNotification(null), 10000);
                
                // Play notification sound if available
                try {
                  const audio = new Audio('data:audio/wav;base64,UklGRiYAAABXQVZFZm10IBAAAAABAAEAQB8AAAB9AAACABAAZGF0YQIAAAAAAA==');
                  audio.play().catch(() => {});
                } catch (e) {
                  console.log('[SOUND] Notification sound not available');
                }
              } else if (newErrand.status === 'accepted') {
                setNotification({
                  message: `✔️ Errand accepted: "${newErrand.title}"`,
                  type: 'updated'
                });
                setTimeout(() => setNotification(null), 5000);
              } else if (newErrand.status === 'assigned') {
                setNotification({
                  message: `👤 Errand assigned: "${newErrand.title}"`,
                  type: 'updated'
                });
                setTimeout(() => setNotification(null), 5000);
              }
            }
          });
        }
        
        setErrands(data.data.errands);
        setPreviousErrands(data.data.errands); // Store for next comparison
        // Cache the errands for 2 minutes to reduce server load
        await cache.setAPIResponse('errands_list', data.data.errands, 2 * 60 * 1000);
        // Collect all uploaded files for transparency
        const allFiles = data.data.errands.flatMap(e => (e.attachments || []));
        setUploadedFiles(allFiles);
      } else {
        console.log('[FETCH_ERRANDS] ❌ No errands data in response');
        setErrands([]);
      }
    } catch (err) {
      console.error('[FETCH_ERRANDS] Error:', err);
    }
  }

  // Helper function to get status badge styling
  function getStatusBadge(status) {
    const badges = {
      'pending': { bg: '#fef3c7', color: '#92400e', icon: '⏳' },
      'assigned': { bg: '#dbeafe', color: '#0c4a6e', icon: '👤' },
      'submitted': { bg: '#e0e7ff', color: '#312e81', icon: '✓' },
      'completed': { bg: '#dcfce7', color: '#166534', icon: '✅' },
      'cancelled': { bg: '#fee2e2', color: '#7f1d1d', icon: '✕' }
    };
    return badges[status] || { bg: '#f3f4f6', color: '#374151', icon: '•' };
  }

  /* eslint-disable react-hooks/exhaustive-deps */
  React.useEffect(() => { 
    fetchErrands();
    // Load user profile on app mount to restore admin status and user info
    if (localStorage.getItem('authToken') || cache.getAuthToken()) {
      loadUserProfile();
    }
    
    // Set up auto-refresh polling for errands every 5 seconds
    // Token check happens inside the interval to handle login/logout
    const interval = setInterval(async () => {
      const token = localStorage.getItem('authToken') || cache.getAuthToken();
      if (token) {
        console.log('[AUTO-REFRESH] Polling triggered at', new Date().toLocaleTimeString());
        setIsRefreshing(true);
        try {
          await fetchErrands(true); // skipCache = true for fresh data
        } catch (err) {
          console.error('[AUTO-REFRESH] Error:', err);
        } finally {
          setIsRefreshing(false);
        }
      }
    }, 5000); // Refresh every 5 seconds
    
    return () => {
      console.log('[AUTO-REFRESH] Cleanup: clearing interval');
      clearInterval(interval);
    }; // Cleanup when component unmounts
  }, []); // Run once on mount
  /* eslint-enable react-hooks/exhaustive-deps */

  // Load user profile data from backend and populate form fields
  async function loadUserProfile() {
    const token = localStorage.getItem('authToken') || cache.getAuthToken();
    if (!token) return;
    
    setIsLoadingProfile(true);
    try {
      // Use GraphQL query instead of REST endpoint
      const query = `query { me { id email firstName lastName phone addressLine1 addressLine2 city state postalCode country isEmailVerified isAdmin transparency { completedErrands documentsHandled } } }`;
      const res = await fetch(`${API_BASE_URL}/graphql`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ query })
      });
      
      if (res.ok) {
        const result = await res.json();
        console.log('[USER PROFILE] GraphQL response:', result);
        
        if (result.errors) {
          console.error('[USER PROFILE] GraphQL error:', result.errors);
          return;
        }
        
        const data = result.data?.me;
        if (!data) {
          console.log('[USER PROFILE] No user data returned');
          return;
        }
        
        console.log('[USER PROFILE] User data:', data);
        
        // Store transparency data
        if (data.transparency) {
          setTransparencyData({
            completed_errands: data.transparency.completedErrands || 0,
            documents_handled: data.transparency.documentsHandled || 0
          });
          console.log('[TRANSPARENCY] Updated:', data.transparency);
        }
        
        // Populate form fields with user data
        if (data.firstName) setAuthFirstName(data.firstName);
        if (data.lastName) setAuthLastName(data.lastName);
        if (data.phone) setAuthPhone(data.phone);
        if (data.email) setAuthEmail(data.email);
        
        // Update user state with all customer details
        const newUser = {
          ...user,
          firstName: data.firstName || '',
          lastName: data.lastName || '',
          email: data.email || '',
          phone: data.phone || '',
          address: [data.addressLine1, data.addressLine2].filter(Boolean).join(', ') || '',
          city: data.city || '',
          country: data.country || '',
          postcode: data.postalCode || '',
          id: data.id,
          isAdmin: data.isAdmin || false
        };
        console.log('[USER PROFILE] Setting user state to:', newUser);
        setUser(newUser);
        
        // Store customer details in localStorage for persistence
        if (data.firstName) localStorage.setItem('lastCustomerFirstName', data.firstName);
        if (data.lastName) localStorage.setItem('lastCustomerLastName', data.lastName);
        if (data.email) localStorage.setItem('lastCustomerEmail', data.email);
        if (data.phone) localStorage.setItem('lastCustomerPhone', data.phone);
        if (data.addressLine1 || data.addressLine2) {
          const fullAddress = [data.addressLine1, data.addressLine2].filter(Boolean).join(', ');
          localStorage.setItem('lastCustomerAddress', fullAddress);
        }
        if (data.city) localStorage.setItem('lastCustomerCity', data.city);
        if (data.country) localStorage.setItem('lastCustomerCountry', data.country);
        if (data.postalCode) localStorage.setItem('lastCustomerPostcode', data.postalCode);
        
        // Check if user is admin
        console.log('[USER PROFILE] Checking admin status:', { isAdmin: data.isAdmin, email: data.email });
        if (data.isAdmin === true) {
          console.log('[USER PROFILE] ✅ User IS admin! Setting userIsAdmin to true');
          setUserIsAdmin(true);
          localStorage.setItem('userIsAdmin', 'true');
        } else {
          console.log('[USER PROFILE] ⚠️ User is NOT admin (isAdmin =', data.isAdmin + ')');
          setUserIsAdmin(false);
          localStorage.setItem('userIsAdmin', 'false');
        }
        
        // Cache user profile for next login
        cache.setUserProfile({
          firstName: data.firstName,
          lastName: data.lastName,
          phone: data.phone,
          email: data.email,
          postcode: data.postal_code
        });
        
        // Also save to localStorage for settings persistence
        localStorage.setItem('userProfile', JSON.stringify({
          firstName: data.first_name,
          lastName: data.last_name,
          phone: data.phone,
          addressLine: data.address_line1,
          city: data.city,
          country: data.country,
          postcode: data.postal_code,
          email: data.email
        }));
        
        // UPDATE USER STATE FOR HEADER DISPLAY - Include admin status
        setUser({
          id: data.id,
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          isAdmin: data.isAdmin
        });
      }
    } catch (err) {
      console.error('[USER PROFILE] Error loading profile:', err);
    } finally {
      setIsLoadingProfile(false);
    }
  }

  async function handleSubmitErrand() {
    if (!title || !agreed) return;
    const token = localStorage.getItem('authToken');
    if (!token) {
      alert('Please log in first');
      setAuthModalOpen(true);
      return;
    }
    
    const mutation = `mutation CreateErrand($input: CreateErrandInput!) { createErrand(input: $input) { id title status referenceNumber pickupTimeSlotDate pickupTimeSlotStart pickupTimeSlotEnd } }`;
    const variables = {
      input: {
        title,
        note,
        templateId: null, // or template if you have an ID
        sensitivity,
        pickupLocation: pickup,
        dropoffLocation: dropoff,
        pickupTimeSlotStart: pickupTimeSlotStart ? new Date(`${pickupTimeSlotDate}T${pickupTimeSlotStart}`).toISOString() : null,
        pickupTimeSlotEnd: pickupTimeSlotEnd ? new Date(`${pickupTimeSlotDate}T${pickupTimeSlotEnd}`).toISOString() : null,
        pickupTimeSlotDate: pickupTimeSlotDate || null,
        userId: user && user.id ? parseInt(user.id, 10) : null  // ← Ensure userId is an integer
      }
    };
    try {
      console.log('Submitting errand with variables:', variables);
      const res = await fetch(`${API_BASE_URL}/graphql`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ query: mutation, variables })
      });
      const data = await res.json();
      console.log('Errand submission response:', data);
      if (!data.errors && data.data && data.data.createErrand && data.data.createErrand.id) {
        const errandId = data.data.createErrand.id;
        const refNumber = data.data.createErrand.referenceNumber || errandId;
        
        // ✅ SHOW SUBMISSION CONFIRMATION MODAL IMMEDIATELY
        setSubmittedErrandData({
          id: errandId,
          title: title,
          referenceNumber: refNumber,
          status: data.data.createErrand.status || 'PENDING',
          pickupTimeSlotDate: pickupTimeSlotDate || null,
          pickupTimeSlotStart: pickupTimeSlotStart || null,
          pickupTimeSlotEnd: pickupTimeSlotEnd || null
        });
        setSubmissionConfirmOpen(true);
        
        // Clear form fields immediately
        setTitle('');
        setNote('');
        setTemplate('Official Document / Office Pickup');
        setSensitivity('Sensitive (documents, money, medicine)');
        setPickup('');
        setDropoff('');
        setAgreed(false);
        setPickupTimeSlotDate('');
        setPickupTimeSlotStart('');
        setPickupTimeSlotEnd('');
        setTemplateJustChanged(false);
        console.log('[FORM CLEAR] All form fields cleared after submission');
        
        // Upload files if any (MUST BE BEFORE clearing file input)
        if (window.uploadedFilesInput && window.uploadedFilesInput.files && window.uploadedFilesInput.files.length > 0) {
          const numFiles = window.uploadedFilesInput.files.length;
          console.log(`[UPLOAD] Uploading ${numFiles} file(s)...`);
          
          for (let i = 0; i < window.uploadedFilesInput.files.length; i++) {
            const file = window.uploadedFilesInput.files[i];
            const formData = new FormData();
            formData.append('file', file);
            // Use XMLHttpRequest to ensure Authorization header is sent
            await new Promise((resolve, reject) => {
              const xhr = new window.XMLHttpRequest();
              xhr.open('POST', `${API_BASE_URL}/errands/${errandId}/attachments`);
              xhr.setRequestHeader('Authorization', `Bearer ${token}`);
              xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                  console.log(`[UPLOAD] File ${i + 1}/${numFiles} (${file.name}) uploaded successfully`);
                  resolve();
                } else {
                  console.error(`[UPLOAD] File ${i + 1} failed with status ${xhr.status}`);
                  reject(xhr.statusText);
                }
              };
              xhr.onerror = function () { 
                console.error(`[UPLOAD] File ${i + 1} network error`);
                reject(xhr.statusText); 
              };
              xhr.send(formData);
            });
          }
          console.log(`[UPLOAD] All ${numFiles} file(s) uploaded! Refreshing errand data...`);
        }
        
        // Clear file input AFTER uploading
        if (window.uploadedFilesInput) {
          window.uploadedFilesInput.value = '';
        }
        // Refresh errands to get updated file counts
        await new Promise(resolve => setTimeout(resolve, 500)); // Small delay to ensure backend processes
        // Clear cache to force fresh fetch
        await cache.clearAPIResponse('errands_list');
        fetchErrands();
        // Refresh transparency data after submission
        await loadUserProfile();
        // Clear form cache after successful submission
        cache.clearFormState();
      }
    } catch (err) {
      // Optionally handle error
    }
  }
  // ...existing code...

  // Removed unreachable duplicate return and redundant block

  // --- MISSING STATE HOOKS FOR PASSWORD RESET AND AUTH ---
  const [resetPwMode, setResetPwMode] = useState(false);
  const [resetPwEmail, setResetPwEmail] = useState('');
  const [resetPwMethod, setResetPwMethod] = useState('link'); // 'link' or 'otp'
  const [resetPwOtpSent, setResetPwOtpSent] = useState(false);
  const [resetPwOtp, setResetPwOtp] = useState('');
  const [resetPwOtpInput, setResetPwOtpInput] = useState('');
  const [resetPwVerified, setResetPwVerified] = useState(false);
  // Address fields - Initialize from cache
  const [authAddressLine, setAuthAddressLine] = useState(() => cache.getUserField('address') || localStorage.getItem('lastCustomerAddress') || '');
  const [authAddressLine2, setAuthAddressLine2] = useState(() => cache.getUserField('address2') || '');
  const [authCity, setAuthCity] = useState(() => cache.getUserField('city') || localStorage.getItem('lastCustomerCity') || '');
  const [authCountry, setAuthCountry] = useState(() => cache.getUserField('country') || localStorage.getItem('lastCustomerCountry') || '');
  const [authPostcode, setAuthPostcode] = useState(() => cache.getUserField('postcode') || localStorage.getItem('lastCustomerPostcode') || '');
  const [authPhone, setAuthPhone] = useState(() => cache.getUserField('phone') || localStorage.getItem('lastCustomerPhone') || '');
  const [showPassword, setShowPassword] = useState(false);

  // --- MISSING HANDLER FUNCTIONS FOR PUZZLE MODAL ---
  function handlePuzzleSubmit(e) {
    e.preventDefault();
    if (puzzleInput.trim().toLowerCase() === PUZZLES[puzzleIdx].a.toLowerCase()) {
      setPuzzleShowAnswer(true);
    } else {
      setPuzzleAttempts(puzzleAttempts + 1);
      if (puzzleAttempts + 1 >= 3) setPuzzleShowAnswer(true);
    }
  }

  function handleNextPuzzle() {
  setPuzzleIdx(getRandomPuzzleIdx(puzzleIdx));
  setPuzzleInput('');
  setPuzzleAttempts(0);
  setPuzzleShowAnswer(false);
  }
  // Placeholder state for user and form fields
  const [user, setUser] = useState(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      return {
        firstName: localStorage.getItem('lastCustomerFirstName') || '',
        lastName: localStorage.getItem('lastCustomerLastName') || '',
        email: localStorage.getItem('lastCustomerEmail') || '',
        phone: localStorage.getItem('lastCustomerPhone') || '',
        address: localStorage.getItem('lastCustomerAddress') || '',
        city: localStorage.getItem('lastCustomerCity') || '',
        country: localStorage.getItem('lastCustomerCountry') || '',
        postcode: localStorage.getItem('lastCustomerPostcode') || '',
        id: localStorage.getItem('userId') || null,
        isAdmin: localStorage.getItem('userIsAdmin') === 'true' // Parse string boolean
      };
    }
    return null;
  });
  // Puzzle modal state
  const [puzzleOpen, setPuzzleOpen] = useState(false);
  const [puzzleIdx, setPuzzleIdx] = useState(getRandomPuzzleIdx());
  const [puzzleInput, setPuzzleInput] = useState("");
  const [puzzleAttempts, setPuzzleAttempts] = useState(0);
  const [puzzleShowAnswer, setPuzzleShowAnswer] = useState(false);

  // Settings modal state
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [userDetailsOpen, setUserDetailsOpen] = useState(false);
  const [profileImage, setProfileImage] = useState(localStorage.getItem('profileImage') || null);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [notifEnabled, setNotifEnabled] = useState(true);
  const [isLoadingProfile, setIsLoadingProfile] = useState(false); // Track when loadUserProfile() is running
  const [changePasswordCurrentPassword, setChangePasswordCurrentPassword] = useState('');
  const [changePasswordNewPassword, setChangePasswordNewPassword] = useState('');
  const [changePasswordConfirmPassword, setChangePasswordConfirmPassword] = useState('');
  const [changePasswordError, setChangePasswordError] = useState('');
  const [changePasswordSuccess, setChangePasswordSuccess] = useState('');
  const [showCurrentPasswordField, setShowCurrentPasswordField] = useState(false);
  const [showNewPasswordField, setShowNewPasswordField] = useState(false);
  const [showConfirmPasswordField, setShowConfirmPasswordField] = useState(false);

  // Errand assignment and review states
  const [reviewModalOpen, setReviewModalOpen] = useState(false);
  const [reviewErrand, setReviewErrand] = useState(null);
  const [reviewRating, setReviewRating] = useState(5);
  const [reviewNotes, setReviewNotes] = useState('');
  const [reviewSubmitting, setReviewSubmitting] = useState(false);
  const [userIsAdmin, setUserIsAdmin] = useState(false); // Track if current user is admin

  // Admin dashboard state
  const [adminDashboardOpen, setAdminDashboardOpen] = useState(false);
  const [adminTab, setAdminTab] = useState('customers'); // 'customers', 'errands', 'attachments', 'issues', 'stats'
  const [adminCustomers, setAdminCustomers] = useState([]);
  const [adminErrandsList, setAdminErrandsList] = useState([]);
  const [adminAttachments, setAdminAttachments] = useState([]);
  const [adminIssues, setAdminIssues] = useState([]);
  const [adminStats, setAdminStats] = useState(null);
  const [adminLoading, setAdminLoading] = useState(false);
  const [transparencyData, setTransparencyData] = useState({ completed_errands: 0, documents_handled: 0 });
  const [selectedErrandDetail, setSelectedErrandDetail] = useState(null); // For errand detail modal
  const [selectedErrandAttachments, setSelectedErrandAttachments] = useState([]); // Attachments for selected errand

  // Log userIsAdmin whenever it changes
  React.useEffect(() => {
    console.log('[ADMIN STATE CHANGED] userIsAdmin =', userIsAdmin);
  }, [userIsAdmin]);

  // Errand submission confirmation state
  const [submissionConfirmOpen, setSubmissionConfirmOpen] = useState(false);
  const [submittedErrandData, setSubmittedErrandData] = useState(null);

  // Auth modal state - Initialize from cache to remember user's email, name, etc.
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authMode, setAuthMode] = useState('login'); // 'login' or 'signup'
  const [authEmail, setAuthEmail] = useState(() => cache.getUserField('email') || localStorage.getItem('lastCustomerEmail') || '');
  const [authPassword, setAuthPassword] = useState('');
  const [authFirstName, setAuthFirstName] = useState(() => cache.getUserField('firstName') || localStorage.getItem('lastCustomerFirstName') || '');
  const [authLastName, setAuthLastName] = useState(() => cache.getUserField('lastName') || localStorage.getItem('lastCustomerLastName') || '');
  // Email verification state
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [pendingVerificationEmail, setPendingVerificationEmail] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [verificationError, setVerificationError] = useState('');
  // Removed unused: authAddress
  const [title, setTitle] = useState("");
  const [template, setTemplate] = useState("Official Document / Office Pickup");
  const [templateJustChanged, setTemplateJustChanged] = useState(false);
  const [note, setNote] = useState("");
  const [sensitivity, setSensitivity] = useState("Sensitive (documents, money, medicine)");
  const [pickup, setPickup] = useState("");
  const [dropoff, setDropoff] = useState("");
  const [pickupTimeSlotStart, setPickupTimeSlotStart] = useState("");
  const [pickupTimeSlotEnd, setPickupTimeSlotEnd] = useState("");
  const [pickupTimeSlotDate, setPickupTimeSlotDate] = useState("");
  // Removed unused: files
  const [agreed, setAgreed] = useState(false);
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  // Location autocomplete state
  const [pickupSuggestions, setPickupSuggestions] = useState([]);
  const [dropoffSuggestions, setDropoffSuggestions] = useState([]);
  const [showPickupSuggestions, setShowPickupSuggestions] = useState(false);
  const [showDropoffSuggestions, setShowDropoffSuggestions] = useState(false);

  // ===== CACHING EFFECTS =====
  // Auto-save auth fields to cache as user types (for quick login next time)
  useEffect(() => {
    // Debounce cache writes to avoid excessive storage operations
    const timer = setTimeout(() => {
      if (authEmail) cache.setUserField('email', authEmail);
      if (authFirstName) cache.setUserField('firstName', authFirstName);
      if (authLastName) cache.setUserField('lastName', authLastName);
      if (authPhone) cache.setUserField('phone', authPhone);
      if (authAddressLine) cache.setUserField('address', authAddressLine);
      if (authAddressLine2) cache.setUserField('address2', authAddressLine2);
      if (authCity) cache.setUserField('city', authCity);
      if (authCountry) cache.setUserField('country', authCountry);
      if (authPostcode) cache.setUserField('postcode', authPostcode);
    }, 500); // Debounce for 500ms
    
    return () => clearTimeout(timer);
  }, [authEmail, authFirstName, authLastName, authPhone, authAddressLine, authAddressLine2, authCity, authCountry, authPostcode]);

  // Auto-save errand form state as user types (draft recovery on page reload)
  useEffect(() => {
    const timer = setTimeout(() => {
      if (title || note) {
        // Only save non-empty forms to avoid clutter
        cache.setFormState({
          title,
          template,
          note,
          sensitivity,
          pickup,
          dropoff,
          pickupTimeSlotStart,
          pickupTimeSlotEnd,
          pickupTimeSlotDate,
          agreed,
        });
        console.log('[CACHE] Errand form auto-saved');
      }
    }, 1000); // Debounce for 1 second
    
    return () => clearTimeout(timer);
  }, [title, template, note, sensitivity, pickup, dropoff, pickupTimeSlotStart, pickupTimeSlotEnd, pickupTimeSlotDate, agreed]);

  // Restore form state from cache on app mount (draft recovery)
  // DISABLED: Auto-restoration of form causes cached data from previous users to appear
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // Only restore form if the user explicitly requests (not on mount)
    // This prevents old user's data appearing when new user logs in
    console.log('[CACHE] Form auto-restoration disabled to prevent data leakage between users');
  }, []); // Empty dependency to run once on mount

  // Removed unused: isSignedUp, setIsSignedUp, pwInput, setPwInput, handleLogout, pickupCoords, setPickupCoords, dropoffCoords, setDropoffCoords

  const templateSuggestions = {
    "Official Document / Office Pickup": `Write your errand note here.
Tip: start from the template and add:
• Office/vendor name
• Reference number
• Pickup window`,
    "Personal Delivery": `Describe the item and recipient.
• Item description
• Recipient name/contact
• Delivery window`,
    "Bank Transaction": `Bank errand details.
• Bank name and branch
• Account reference number
• Transaction type (deposit, withdrawal, etc.)
• Amount (if applicable)
• Required documents (ID, proof of address)`,
    "Medical / Pharmacy Pickup": `Medical errand details.
• Pharmacy or clinic name
• Prescription/order reference
• Pickup name
• Special handling (temperature-sensitive, fragile)
• Delivery recipient`,
    "Government Office / Immigration": `Official documentation errand.
• Government agency name
• Service type (visa, permit, license, etc.)
• Reference number
• Documents required
• Pickup location and hours
• Required ID or authorization letter`,
    "Hotel / Hospitality": `Hotel-related errand.
• Hotel name and reference
• Guest name
• Room number
• Item description
• Delivery location (room, front desk, etc.)
• Contact person`,
    "International Parcel": `Cross-border shipment details.
• Sender location
• Recipient location
• Package contents (for customs)
• Declared value
• Required documentation (commercial invoice, etc.)
• Insurance needs`,
    "Legal / Notary": `Legal document handling.
• Law firm or notary name
• Document type (contract, affidavit, etc.)
• Recipient location
• Delivery deadline
• Signature requirements`,
    "Corporate Logistics": `Business-to-business delivery.
• Company name and contact
• Item/document description
• Quantity
• Special delivery instructions
• Receipt confirmation required`,
    "Other": `Describe your errand in detail.
• What needs to be done
• Any special instructions
• Contact info`
  };

  function handleTemplateChange(e) {
    setTemplate(e.target.value);
    setNote(templateSuggestions[e.target.value] || "");
  }

  function handleResetTemplate() {
    setNote(templateSuggestions[template] || "");
  }

  function handleClearTemplate() {
    setNote("");
  }

  function handleUseSuggestion() {
    setNote(templateSuggestions[template] || "");
  }

  // Function to detect best matching template from title keywords
  function detectTemplateFromTitle(titleText) {
    if (!titleText || titleText.trim().length === 0) return null;
    
    const titleLower = titleText.toLowerCase();
    
    // Define keyword patterns for each template
    const templateKeywords = {
      "Official Document / Office Pickup": ["office", "document", "pickup", "file", "report", "memo", "contract"],
      "Bank Transaction": ["bank", "account", "deposit", "withdrawal", "transaction", "finance", "check"],
      "Medical / Pharmacy Pickup": ["pharmacy", "medicine", "prescription", "doctor", "hospital", "clinic", "medical", "drug"],
      "Government Office / Immigration": ["government", "visa", "passport", "immigration", "permit", "license", "official", "agency"],
      "Hotel / Hospitality": ["hotel", "guest", "room", "hospitality", "reservation", "check-in"],
      "International Parcel": ["parcel", "international", "customs", "shipping", "cross-border", "export", "import"],
      "Legal / Notary": ["legal", "notary", "lawyer", "contract", "affidavit", "court", "attorney"],
      "Corporate Logistics": ["corporate", "business", "company", "office", "logistics", "delivery", "shipment"],
      "Personal Delivery": ["deliver", "personal", "send", "gift", "item", "package"],
      "Other": []
    };
    
    let bestMatch = null;
    let bestScore = 0;
    
    // Score each template based on keyword matches
    for (const [templateName, keywords] of Object.entries(templateKeywords)) {
      let score = 0;
      for (const keyword of keywords) {
        if (titleLower.includes(keyword)) {
          score += 1;
        }
      }
      
      // If this template has more matches than current best, use it
      if (score > bestScore) {
        bestScore = score;
        bestMatch = templateName;
      }
    }
    
    // Return best match if we found something, otherwise return null
    return bestScore > 0 ? bestMatch : null;
  }

  const [aiLoading, setAiLoading] = useState(false);
  const [aiError, setAiError] = useState("");

  // AI Title suggestions state
  const [titleSuggestions, setTitleSuggestions] = useState([]);
  const [showTitleSuggestions, setShowTitleSuggestions] = useState(false);
  const [titleLoading, setTitleLoading] = useState(false);

  async function handleAISuggest() {
    if (!note.trim()) {
      setAiError("Please enter a description first");
      setTimeout(() => setAiError(""), 3000);
      return;
    }

    setAiLoading(true);
    setAiError("");

    try {
      const response = await fetch(`${API_BASE_URL}/prompt/ai-suggest`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          description: note.trim(),
          template_id: template
        })
      });

      if (!response.ok) throw new Error("Failed to get AI suggestion");

      const data = await response.json();
      
      // Track if template was auto-detected
      let templateChanged = false;
      
      // Update with AI suggestions
      if (data.title) {
        console.log("AI suggested title:", data.title);
      }
      if (data.description) {
        setNote(data.description);
      }
      if (data.suggested_template && data.suggested_template !== template) {
        setTemplate(data.suggested_template);
        templateChanged = true;
      }
      
      // Show success message with template info if it changed
      if (templateChanged) {
        setAiError(`✅ AI enhanced your description & suggested template: ${data.suggested_template}`);
        setTimeout(() => setAiError(""), 4000);
      }
    } catch (err) {
      setAiError("AI suggestion failed. Using your original description.");
      console.error("AI suggest error:", err);
    } finally {
      setAiLoading(false);
    }
  }

  async function handleAITitleSuggest() {
    if (!note.trim()) {
      setAiError("Please enter a description first");
      setTimeout(() => setAiError(""), 3000);
      return;
    }

    setTitleLoading(true);
    setAiError("");

    try {
      // Auto-detect best matching template from title if user has typed one
      let detectedTemplate = template;
      
      if (title.trim().length > 0) {
        const detected = detectTemplateFromTitle(title);
        if (detected && detected !== template) {
          detectedTemplate = detected;
          setTemplate(detected);
          setTemplateJustChanged(true);
          console.log('[AI TITLE] Template auto-detected and changed from', template, 'to', detected);
          // Show visual feedback that template changed
          setAiError(`✨ Auto-selected template: "${detected}"`);
          // Clear highlight after 2 seconds
          setTimeout(() => setTemplateJustChanged(false), 2000);
          // Update note to match the newly detected template
          setNote(templateSuggestions[detected] || "");
        }
      }

      const response = await fetch(`${API_BASE_URL}/prompt/ai-suggest`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          description: note.trim(),
          template_id: detectedTemplate,
          suggest_titles_only: true
        })
      });

      if (!response.ok) throw new Error("Failed to get AI title suggestions");

      const data = await response.json();
      
      // Parse title suggestions - could be array or string with newlines
      let suggestions = [];
      if (Array.isArray(data.title_suggestions)) {
        suggestions = data.title_suggestions.filter(t => t && t.trim()).slice(0, 5);
      } else if (data.title_suggestions && typeof data.title_suggestions === 'string') {
        suggestions = data.title_suggestions
          .split('\n')
          .map(t => t.replace(/^\d+\.\s*/, '').trim())
          .filter(t => t && t.length > 5 && t.length < 150)
          .slice(0, 5);
      } else if (data.title) {
        suggestions = [data.title];
      }

      if (suggestions.length > 0) {
        setTitleSuggestions(suggestions);
        setShowTitleSuggestions(true);
      } else {
        setAiError("No title suggestions generated. Try a more detailed description.");
        setTimeout(() => setAiError(""), 3000);
      }
    } catch (err) {
      setAiError("Title suggestion failed. Try again.");
      console.error("AI title suggest error:", err);
    } finally {
      setTitleLoading(false);
    }
  }

  // Location autocomplete functions
  const commonLocations = [
    // Nigerian Cities (expanded)
    "Lagos, Nigeria", "Abuja, Nigeria", "Port Harcourt, Nigeria",
    "Kano, Nigeria", "Ibadan, Nigeria", "Benin City, Nigeria",
    "Enugu, Nigeria", "Owerri, Nigeria", "Onitsha, Nigeria",
    "Akure, Nigeria", "Ilorin, Nigeria", "Abeokuta, Nigeria",
    "Calabar, Nigeria", "Uyo, Nigeria", "Warri, Nigeria",
    "Kaduna, Nigeria", "Katsina, Nigeria", "Maiduguri, Nigeria",
    "Sokoto, Nigeria", "Bauchi, Nigeria", "Lafia, Nigeria",
    // UK Cities
    "London, UK", "Manchester, UK", "Birmingham, UK",
    // USA Cities
    "New York, USA", "Los Angeles, USA", "Chicago, USA",
    // Other Countries
    "Toronto, Canada", "Vancouver, Canada",
    "Sydney, Australia", "Melbourne, Australia",
    "Singapore", "Dubai, UAE", "Bangkok, Thailand"
  ];

  const handlePickupInput = (value) => {
    setPickup(value);
    if (value.length > 1) {
      const filtered = commonLocations.filter(loc =>
        loc.toLowerCase().includes(value.toLowerCase())
      );
      setPickupSuggestions(filtered.slice(0, 5));
      setShowPickupSuggestions(filtered.length > 0);
    } else {
      setPickupSuggestions([]);
      setShowPickupSuggestions(false);
    }
  };

  const handleDropoffInput = (value) => {
    setDropoff(value);
    if (value.length > 1) {
      const filtered = commonLocations.filter(loc =>
        loc.toLowerCase().includes(value.toLowerCase())
      );
      setDropoffSuggestions(filtered.slice(0, 5));
      setShowDropoffSuggestions(filtered.length > 0);
    } else {
      setDropoffSuggestions([]);
      setShowDropoffSuggestions(false);
    }
  };

  const selectPickupLocation = (location) => {
    setPickup(location);
    setShowPickupSuggestions(false);
    // In future: geocode location to get coordinates
    // setPickupCoords({ lat, lng });
  };

  const selectDropoffLocation = (location) => {
    setDropoff(location);
    setShowDropoffSuggestions(false);
    // In future: geocode location to get coordinates
    // setDropoffCoords({ lat, lng });
  };

  const toggleInfos = [
    "EU/US → Lagos (focus): Currently supporting errands from EU/US to Lagos. More routes coming soon.",
    "Proof-first delivery: Runner must provide proof (photo/receipt/scan) before delivery is confirmed.",
    "Data minimisation by default: Only essential data is collected and stored.",
    "Assisted resolution if an issue occurs: We help resolve disputes or issues with your errand.",
    "No hidden fees: Transparent pricing, no surprise charges.",
    "Verified runners: All service providers have been rigorously vetted, background checked, and verified for reliability. Our pilot program ensures only trusted runners handle your items. Each runner is rated by customers and continuously monitored for quality assurance."
  ];
  const [infoOpen, setInfoOpen] = useState(false);
  const [infoContent, setInfoContent] = useState("");
  
  // Edit errand modal state
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editingErrand, setEditingErrand] = useState(null);
  const [editFormData, setEditFormData] = useState({});
  function handleToggleInfo(idx) {
    setInfoContent(toggleInfos[idx]);
    setInfoOpen(true);
  }

  const buttonStyle = {
    padding: "8px 18px",
    borderRadius: 10,
    border: "none",
    background: "#f3f4f6",
    fontWeight: 600,
    cursor: "pointer",
    boxShadow: "0 1px 4px #0001",
    transition: "background 0.2s"
  };

  // GraphQL-based auth function (more reliable than REST endpoints)
  async function graphqlAuth(isLogin) {
    const mutation = isLogin 
      ? `mutation { 
          login(input: { email: "${authEmail}", password: "${authPassword}" }) {
            accessToken userId email firstName lastName phone addressLine1 addressLine2 city state postalCode country isEmailVerified isAdmin
          }
        }`
      : `mutation {
          signup(input: { 
            email: "${authEmail}", 
            password: "${authPassword}",
            firstName: "${authFirstName}",
            lastName: "${authLastName}",
            phone: "${authPhone}",
            addressLine1: ${authAddressLine ? `"${authAddressLine.replace(/"/g, '\\"')}"` : 'null'},
            addressLine2: ${authAddressLine2 ? `"${authAddressLine2.replace(/"/g, '\\"')}"` : 'null'},
            city: ${authCity ? `"${authCity.replace(/"/g, '\\"')}"` : 'null'},
            state: null,
            postalCode: ${authPostcode ? `"${authPostcode.replace(/"/g, '\\"')}"` : 'null'},
            country: ${authCountry ? `"${authCountry.replace(/"/g, '\\"')}"` : 'null'}
          }) {
            accessToken userId email firstName lastName phone addressLine1 addressLine2 city state postalCode country isEmailVerified isAdmin
          }
        }`;

    console.log(`[AUTH] Calling GraphQL ${isLogin ? 'login' : 'signup'} mutation`);
    console.log(`[AUTH] API_BASE_URL: ${API_BASE_URL}`);
    console.log(`[AUTH] Email: ${isLogin ? authEmail : authEmail}`);
    
    try {
      const fullUrl = `${API_BASE_URL}/graphql`;
      const body = JSON.stringify({ query: mutation });
      
      console.log(`[AUTH] Fetching from: ${fullUrl}`);
      
      // Standard fetch - iOS simulator should handle this
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 15000);
      
      const res = await fetch(fullUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      console.log(`[AUTH] Fetch response received, status: ${res.status}`);

      if (!res.ok) {
        const errorText = await res.text();
        console.error('[AUTH] HTTP error response:', errorText);
        throw new Error(`HTTP ${res.status}: ${errorText}`);
      }

      const result = await res.json();
      console.log('[AUTH] GraphQL response:', result);

      if (result.errors && result.errors.length > 0) {
        throw new Error(result.errors[0].message || 'Authentication failed');
      }

      const authData = isLogin ? result.data.login : result.data.signup;
      if (!authData) {
        throw new Error('No auth data returned');
      }

      return authData;
    } catch (err) {
      console.error('[AUTH] Error caught in graphqlAuth');
      console.error('[AUTH] Error type:', err.constructor.name);
      console.error('[AUTH] Error name:', err.name);
      console.error('[AUTH] Error message:', err.message);
      console.error('[AUTH] Error code:', err.code);
      console.error('[AUTH] Stack:', err.stack);
      
      if (err.name === 'AbortError') {
        throw new Error('Request timeout');
      }
      throw err;
    }
  }

  // Helper function to switch to signup mode with clean form fields
  function switchToSignupMode() {
    setAuthMode('signup');
    setAuthModalOpen(true);
    // Clear all form fields for a fresh signup
    setAuthEmail('');
    setAuthPassword('');
    setAuthFirstName('');
    setAuthLastName('');
    setAuthPhone('');
    setAuthCountry('');
    setAuthAddressLine('');
    setAuthAddressLine2('');
    setAuthCity('');
    setAuthPostcode('');
    setShowPassword(false);
  }

  async function handleAuthSubmit(e) {
    e.preventDefault();
    if (resetPwMode) {
      setResetPwMode(false);
      setAuthModalOpen(false);
      setResetPwEmail('');
      return;
    }
    
    console.log(`[AUTH] ${authMode === 'login' ? 'LOGIN' : 'SIGNUP'} - Using GraphQL mutation`);

    try {
      // Use GraphQL mutations instead of REST endpoints
      const authData = await graphqlAuth(authMode === 'login');
      
      console.log(`[AUTH] Response received:`, authData);
      
      // After signup, show email verification modal
      if (authMode === 'signup' && authData.accessToken && !authData.error) {
        console.log(`[AUTH] Signup successful - showing verification modal for ${authEmail}`);
        setPendingVerificationEmail(authEmail);
        setShowVerificationModal(true);
        setVerificationCode('');
        setVerificationError('');
        // Clear password from auth modal (but keep email and names)
        setAuthPassword('');
        return;
      }
      
      if (authData.accessToken) {
        // Store token and user info (for login)
        console.log('[LOGIN] Storing auth token and user info to cache');
        console.log('[LOGIN] Token:', authData.accessToken.substring(0, 50) + '...');
        console.log('[LOGIN] User ID:', authData.userId);
        console.log('[LOGIN] isAdmin:', authData.isAdmin);
        
        // IMPORTANT: Clear old customer data from localStorage when logging in with new token
        // This prevents showing old customer's data when a new customer logs in
        localStorage.setItem('lastCustomerEmail', authData.email);
        localStorage.setItem('lastCustomerFirstName', authData.firstName || '');
        localStorage.setItem('lastCustomerLastName', authData.lastName || '');
        localStorage.setItem('lastCustomerPhone', authData.phone || '');
        localStorage.setItem('lastCustomerAddress', [authData.addressLine1, authData.addressLine2].filter(Boolean).join(', '));
        localStorage.setItem('lastCustomerCity', authData.city || '');
        localStorage.setItem('lastCustomerCountry', authData.country || '');
        localStorage.setItem('lastCustomerPostcode', authData.postalCode || '');
        
        // Use new cache system - stores email, names with auto-expire
        cache.setAuthToken(authData.accessToken, 86400);
        cache.setUserField('email', authData.email);
        cache.setUserField('firstName', authData.firstName || authFirstName);
        cache.setUserField('lastName', authData.lastName || authLastName);
        
        // Also set full profile for later use
        const profileData = {
          email: authData.email,
          firstName: authData.firstName || authFirstName,
          lastName: authData.lastName || authLastName,
          ...(authData.phone && { phone: authData.phone }),
          ...(authData.addressLine1 && { addressLine1: authData.addressLine1 }),
          ...(authData.addressLine2 && { addressLine2: authData.addressLine2 }),
          ...(authData.city && { city: authData.city }),
          ...(authData.state && { state: authData.state }),
          ...(authData.postalCode && { postalCode: authData.postalCode }),
          ...(authData.country && { country: authData.country }),
        };
        cache.setUserProfile(profileData);
        
        // Keep legacy localStorage for backward compatibility
        localStorage.setItem('authToken', authData.accessToken);
        localStorage.setItem('userId', authData.userId);
        localStorage.setItem('userIsAdmin', authData.isAdmin ? 'true' : 'false');
        
        // Store address fields in localStorage
        if (authData.addressLine1) localStorage.setItem('lastCustomerAddress', [authData.addressLine1, authData.addressLine2].filter(Boolean).join(', '));
        if (authData.city) localStorage.setItem('lastCustomerCity', authData.city);
        if (authData.country) localStorage.setItem('lastCustomerCountry', authData.country);
        if (authData.postalCode) localStorage.setItem('lastCustomerPostcode', authData.postalCode);
        
        console.log('[LOGIN] Verifying cache was set:');
        console.log('[LOGIN] Auth token in cache:', cache.getAuthToken() ? 'YES' : 'NO');
        
        // Set user state - Include all customer details from auth response
        setUser({ 
          id: authData.userId,
          firstName: authData.firstName || authFirstName, 
          lastName: authData.lastName || authLastName, 
          email: authData.email,
          phone: authData.phone || '',
          address: [authData.addressLine1, authData.addressLine2].filter(Boolean).join(', ') || '',
          city: authData.city || '',
          country: authData.country || '',
          postcode: authData.postalCode || '',
          isAdmin: authData.isAdmin
        });
        
        // Also update userIsAdmin state immediately
        setUserIsAdmin(authData.isAdmin ? true : false);
        
        setAuthModalOpen(false);
        setAuthEmail(''); 
        setAuthPassword(''); 
        setAuthFirstName(''); 
        setAuthLastName('');
        
        console.log('[LOGIN] Calling loadUserProfile()...');
        // Load full user profile from backend
        await loadUserProfile();
        
        console.log('[LOGIN] Calling fetchErrands()...');
        // Refresh errands with new token
        fetchErrands();
      }
    } catch (err) {
      console.error('[AUTH] Error:', err);
      alert('Auth failed: ' + err.message);
    }
  }

  // Handle email verification after signup
  async function handleVerifyEmail(e) {
    e.preventDefault();
    console.log(`[VERIFY] Attempting to verify code for ${pendingVerificationEmail}: ${verificationCode}`);
    
    if (!verificationCode.trim()) {
      console.log(`[VERIFY] Error: No code entered`);
      setVerificationError('Please enter the verification code');
      return;
    }

    try {
      const res = await fetch(`${API_BASE_URL}/auth/confirm`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: pendingVerificationEmail,
          code: verificationCode.trim()
        })
      });
      
      const data = await res.json();
      console.log(`[VERIFY] Response status: ${res.status}, data:`, data);
      
      if (data.ok || res.ok) {
        // Email verified successfully
        console.log(`[VERIFY] Success! Email verified.`);
        setVerificationError('');
        setShowVerificationModal(false);
        setVerificationCode('');
        
        // Load full user profile after verification
        await loadUserProfile();
        
        setAuthMode('login');
        alert('Email verified! You can now log in with your credentials.');
      } else {
        console.log(`[VERIFY] Error: ${data.detail}`);
        setVerificationError(data.detail || 'Invalid code. Please try again.');
      }
    } catch (err) {
      console.error(`[VERIFY] Exception:`, err);
      setVerificationError('Verification failed: ' + err.message);
    }
  }

  // Handle resending verification code
  async function handleResendVerificationCode() {
    try {
      const res = await fetch(`${API_BASE_URL}/auth/resend`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: pendingVerificationEmail })
      });
      
      const data = await res.json();
      if (data.ok || res.ok) {
        setVerificationError('');
        alert('New code sent to ' + pendingVerificationEmail);
      } else {
        setVerificationError(data.detail || 'Failed to resend code');
      }
    } catch (err) {
      setVerificationError('Resend failed: ' + err.message);
    }
  }

  // Handle password change
  async function handleChangePassword(e) {
    e.preventDefault();
    setChangePasswordError('');
    setChangePasswordSuccess('');

    // Validate form
    if (!changePasswordCurrentPassword.trim()) {
      setChangePasswordError('Please enter your current password');
      return;
    }
    if (!changePasswordNewPassword.trim()) {
      setChangePasswordError('Please enter a new password');
      return;
    }
    if (changePasswordNewPassword.length < 8) {
      setChangePasswordError('New password must be at least 8 characters');
      return;
    }
    if (changePasswordNewPassword !== changePasswordConfirmPassword) {
      setChangePasswordError('Passwords do not match');
      return;
    }
    if (changePasswordNewPassword === changePasswordCurrentPassword) {
      setChangePasswordError('New password must be different from current password');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(`${API_BASE_URL}/auth/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          current_password: changePasswordCurrentPassword,
          new_password: changePasswordNewPassword
        })
      });

      const data = await res.json();
      
      if (res.ok || data.ok) {
        setChangePasswordSuccess('Password changed successfully!');
        setChangePasswordCurrentPassword('');
        setChangePasswordNewPassword('');
        setChangePasswordConfirmPassword('');
        setTimeout(() => {
          setShowChangePassword(false);
          setChangePasswordSuccess('');
        }, 2000);
      } else {
        setChangePasswordError(data.detail || data.error || 'Failed to change password');
      }
    } catch (err) {
      setChangePasswordError('Error: ' + err.message);
    }
  }

  // Settings modal: allow editing and saving customer info
  // Removed unused: editMode
  const [editFirstName, setEditFirstName] = useState(user ? user.firstName : '');
  const [editLastName, setEditLastName] = useState(user ? user.lastName : '');
  const [editEmail, setEditEmail] = useState(user ? user.email : '');
  const [editAddress, setEditAddress] = useState(user && user.address ? user.address : '');
  const [editCity, setEditCity] = useState(user && user.city ? user.city : '');
  const [editCountry, setEditCountry] = useState(user && user.country ? user.country : '');
  const [editPostcode, setEditPostcode] = useState(user && user.postcode ? user.postcode : '');
  const [editPhone, setEditPhone] = useState(user && user.phone ? user.phone : '');

  // Load user data when settings modal opens
  React.useEffect(() => {
    if (settingsOpen && user) {
      setEditFirstName(user.firstName || '');
      setEditLastName(user.lastName || '');
      setEditEmail(user.email || '');
      setEditAddress(user.address || '');
      setEditCity(user.city || '');
      setEditCountry(user.country || '');
      setEditPostcode(user.postcode || '');
      setEditPhone(user.phone || '');
    }
  }, [settingsOpen, user]);

  function handleSaveSettings(e) {
    e.preventDefault();
    setUser({
      ...user,
      firstName: editFirstName,
      lastName: editLastName,
      email: editEmail,
      address: editAddress,
      city: editCity,
      country: editCountry,
      postcode: editPostcode,
      phone: editPhone
    });
  }

  // Handle account deactivation
  async function handleDeactivateAccount() {
    const confirmDeactivate = window.confirm(
      '⚠️ WARNING: Deactivating your account will:\n\n' +
      '• Permanently delete your profile data\n' +
      '• Archive all your errands\n' +
      '• Make your account inaccessible\n\n' +
      'This action CANNOT be undone. Are you sure?'
    );
    
    if (!confirmDeactivate) return;
    
    const confirmAgain = window.prompt(
      'Type "DEACTIVATE" to confirm permanent account deletion:'
    );
    
    if (confirmAgain !== 'DEACTIVATE') {
      alert('Account deactivation cancelled.');
      return;
    }
    
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/auth/deactivate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      
      const data = await response.json();
      if (response.ok) {
        // Clear local storage
        localStorage.removeItem('authToken');
        localStorage.removeItem('userId');
        localStorage.removeItem('userName');
        cache.clearAll();
        // Logout
        setUser(null);
        setSettingsOpen(false);
      } else {
        alert(`Error: ${data.detail || 'Failed to deactivate account'}`);
      }
    } catch (err) {
      console.error('Deactivation error:', err);
      alert('Failed to deactivate account. Please try again.');
    }
  }

  // Handle profile image upload
  function handleProfileImageUpload(e) {
    const file = e.target.files?.[0];
    if (file) {
      // Check file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('Image size must be less than 5MB');
        return;
      }

      // Check file type
      if (!file.type.startsWith('image/')) {
        alert('Please upload an image file');
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        const imageData = event.target?.result;
        if (imageData) {
          setProfileImage(imageData);
          localStorage.setItem('profileImage', imageData);
        }
      };
      reader.readAsDataURL(file);
    }
  }

  // Admin Dashboard Functions
  const loadAdminData = useCallback(async () => {
    setAdminLoading(true);
    try {
      const token = localStorage.getItem('authToken') || cache.getAuthToken();
      if (!token) {
        alert('Not authenticated');
        return;
      }

      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      };

      // Load all admin data based on current tab
      if (adminTab === 'customers') {
        const res = await fetch(`${API_BASE_URL}/admin/customers`, { headers });
        const data = await res.json();
        setAdminCustomers(Array.isArray(data) ? data : data.customers || []);
      } else if (adminTab === 'errands') {
        const res = await fetch(`${API_BASE_URL}/admin/errands`, { headers });
        const data = await res.json();
        setAdminErrandsList(Array.isArray(data) ? data : data.errands || []);
      } else if (adminTab === 'attachments') {
        const res = await fetch(`${API_BASE_URL}/admin/attachments`, { headers });
        const data = await res.json();
        setAdminAttachments(Array.isArray(data) ? data : data.attachments || []);
      } else if (adminTab === 'issues') {
        const res = await fetch(`${API_BASE_URL}/admin/issues`, { headers });
        const data = await res.json();
        setAdminIssues(Array.isArray(data) ? data : data.issues || []);
      } else if (adminTab === 'stats') {
        const res = await fetch(`${API_BASE_URL}/admin/customers/stats`, { headers });
        const data = await res.json();
        setAdminStats(data);
      }
    } catch (err) {
      console.error('Error loading admin data:', err);
      alert('Failed to load admin data');
    }
    setAdminLoading(false);
  }, [adminTab]);

  async function handleSelectErrandDetail(errand) {
    setSelectedErrandDetail(errand);
    
    // Fetch attachments for this errand
    try {
      const token = localStorage.getItem('authToken') || cache.getAuthToken();
      if (!token) {
        setSelectedErrandAttachments([]);
        return;
      }
      
      const response = await fetch(`${API_BASE_URL}/admin/attachments?errand_id=${errand.id}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      
      const data = await response.json();
      setSelectedErrandAttachments(Array.isArray(data) ? data : data.attachments || []);
    } catch (err) {
      console.error('Error fetching errand attachments:', err);
      setSelectedErrandAttachments([]);
    }
  }

  // Reload admin data when tab changes
  React.useEffect(() => {
    if (adminDashboardOpen) {
      loadAdminData();
    }
  }, [adminTab, adminDashboardOpen, loadAdminData]);

  async function handleApproveErrand(errandId) {
    try {
      const token = localStorage.getItem('authToken') || cache.getAuthToken();
      if (!token) {
        alert('Not authenticated');
        return;
      }
      
      // Optimistic update: update local state immediately
      setAdminErrandsList(prev => 
        prev.map(e => e.id === errandId ? { ...e, status: 'completed' } : e)
      );
      
      const response = await fetch(`${API_BASE_URL}/admin/errands/${errandId}/status`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ status: 'completed' })
      });
      
      const data = await response.json();
      if (!response.ok) {
        alert(`❌ Error approving errand: ${data.detail || 'Unknown error'}`);
        loadAdminData();
        return;
      }

      alert('✅ Errand approved successfully!');
      loadAdminData();
    } catch (err) {
      console.error('Error approving errand:', err);
      alert('❌ Failed to approve errand. Please try again.');
      loadAdminData();
    }
  }

  async function handleReviewAttachment(attachmentId, action) {
    try {
      const token = localStorage.getItem('authToken') || cache.getAuthToken();
      if (!token) {
        alert('Not authenticated');
        return;
      }
      
      const response = await fetch(`${API_BASE_URL}/admin/attachments/${attachmentId}/review`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ action })
      });
      
      const data = await response.json();
      if (response.ok) {
        alert(`✅ Attachment ${action === 'approve' ? 'approved' : 'rejected'}!`);
        loadAdminData();
      } else {
        alert(`Error: ${data.detail || 'Failed to review attachment'}`);
      }
    } catch (err) {
      console.error('Error reviewing attachment:', err);
      alert('Failed to review attachment. Please try again.');
    }
  }

  async function handleResolveIssue(issueId, resolution) {
    try {
      const token = localStorage.getItem('authToken') || cache.getAuthToken();
      if (!token) {
        alert('Not authenticated');
        return;
      }
      
      const response = await fetch(`${API_BASE_URL}/admin/issues/${issueId}/resolve`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ resolution })
      });
      
      const data = await response.json();
      if (response.ok) {
        alert(`✅ Issue resolved as: ${resolution}!`);
        loadAdminData();
      } else {
        alert(`Error: ${data.detail || 'Failed to resolve issue'}`);
      }
    } catch (err) {
      console.error('Error resolving issue:', err);
      alert('Failed to resolve issue. Please try again.');
    }
  }

  async function handleCompleteErrand(errandId) {
    const confirmComplete = window.confirm('Mark this errand as completed?');
    if (!confirmComplete) return;
    
    try {
      const token = localStorage.getItem('authToken') || cache.getAuthToken();
      if (!token) {
        alert('Not authenticated');
        return;
      }
      
      // Optimistic update: update local state immediately
      setAdminErrandsList(prev => 
        prev.map(e => e.id === errandId ? { ...e, status: 'completed' } : e)
      );
      
      const response = await fetch(`${API_BASE_URL}/admin/errands/${errandId}/status`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ status: 'completed' })
      });
      
      const data = await response.json();
      if (response.ok) {
        alert('✅ Errand marked as completed!');
        loadAdminData();
      } else {
        alert(`Error: ${data.detail || 'Failed to complete errand'}`);
        loadAdminData(); // Refresh on error
      }
    } catch (err) {
      console.error('Error completing errand:', err);
      alert('Failed to complete errand. Please try again.');
      loadAdminData(); // Refresh on error
    }
  }

  // Handle customer accepting a completed errand
  async function handleAcceptCompleteErrand(errandId) {
    const confirmAccept = window.confirm('Accept this completed errand?');
    if (!confirmAccept) return;
    
    try {
      const token = localStorage.getItem('authToken') || cache.getAuthToken();
      if (!token) {
        alert('Not authenticated');
        return;
      }
      
      // Optimistic update: update local state immediately
      setErrands(prev => 
        prev.map(e => e.id === errandId ? { ...e, status: 'accepted' } : e)
      );
      
      const response = await fetch(`${API_BASE_URL}/admin/errands/${errandId}/status`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ status: 'accepted' })
      });
      
      const data = await response.json();
      if (response.ok) {
        alert('✅ Errand accepted! Thank you.');
        fetchErrands(); // Refresh errands
      } else {
        alert(`Error: ${data.detail || 'Failed to accept errand'}`);
        fetchErrands(); // Refresh on error
      }
    } catch (err) {
      console.error('Error accepting errand:', err);
      alert('Failed to accept errand. Please try again.');
      fetchErrands(); // Refresh on error
    }
  }

  return (
    <div style={{ fontFamily: "system-ui, sans-serif", background: "#f7f8fa", minHeight: "100vh" }}>
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes slideDown {
          from {
            transform: translateY(-100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .notification {
          animation: slideDown 0.3s ease-out;
        }
      `}</style>
      
      {/* Notification Banner */}
      {notification && (
        <div className="notification" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          background: notification.type === 'approved' ? '#059669' : '#3b82f6',
          color: '#fff',
          padding: '16px 24px',
          textAlign: 'center',
          fontWeight: 600,
          fontSize: 16,
          zIndex: 1000,
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12
        }}
        onClick={() => {
          if (notification.errandId) {
            setDetailsModal({ open: true, errand: errands.find(e => e.id === notification.errandId) });
          }
          setNotification(null);
        }}
        >
          <span style={{ fontSize: 20 }}>
            {notification.type === 'approved' ? '✅' : 'ℹ️'}
          </span>
          <span>{notification.message}</span>
        </div>
      )}
      
      {/* Header */}
      <header style={{ 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "space-between", 
        padding: "24px 36px 0 36px", 
        background: "transparent", 
        borderBottom: "none", 
        minHeight: 80, 
        gap: "14px"
      }}>
        <div style={{ display: "flex", alignItems: "center", minWidth: 0 }}>
          <button 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            style={{ 
              background: 'none', 
              border: 'none', 
              padding: 0, 
              cursor: 'pointer',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              borderRadius: 14,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
            title="Go to home"
          >
            <img src={require('./errandbridge_logo_full.png')} alt="ErrandBridge Logo" style={{ 
              height: "90px",
              background: '#fff', 
              borderRadius: 14, 
              boxShadow: '0 2px 8px #0001', 
              padding: 6, 
              display: 'block' 
            }} />
          </button>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "14px", flexWrap: "nowrap", justifyContent: "flex-end" }}>
          {user && (
            <button 
              onClick={() => setUserDetailsOpen(true)}
              style={{ 
                background: 'none', 
                border: 'none', 
                padding: '6px 12px', 
                cursor: 'pointer',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                borderRadius: 8,
                fontWeight: 600,
                fontSize: "16px",
                color: '#2563eb',
                marginRight: 0,
                whiteSpace: 'nowrap',
                flexShrink: 0
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(37, 99, 235, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              title="Click to view your details"
            >
              {isCapacitor ? user.firstName : `${user.firstName} ${user.lastName}`}
            </button>
          )}
          {userIsAdmin && (
            <button 
              style={{ 
                ...buttonStyle, 
                background: '#8b5cf6', 
                color: '#fff', 
                transition: 'transform 0.3s ease'
              }} 
              onClick={() => setAdminDashboardOpen(true)}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(139, 92, 246, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              title="Admin Dashboard"
            >
              {isCapacitor ? '👨‍💼' : '👨‍💼 Admin'}
            </button>
          )}
          <button 
            style={{ 
              ...buttonStyle, 
              transition: 'transform 0.3s ease'
            }} 
            onClick={() => setPuzzleOpen(true)}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(37, 99, 235, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
            title="Puzzle"
          >
            {isCapacitor ? '🧩' : 'Puzzle'}
          </button>
          <button 
            style={{ 
              ...buttonStyle, 
              transition: 'transform 0.3s ease'
            }} 
            onClick={() => setSettingsOpen(true)}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(37, 99, 235, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
            title="Settings"
          >
            {isCapacitor ? '⚙️' : 'Settings'}
          </button>
          {user ? (
            <button
              style={{ 
                ...buttonStyle, 
                background: "#e74c3c", 
                color: "#fff", 
                transition: 'transform 0.3s ease'
              }}
              onClick={() => { 
                // Clear all auth and customer data from localStorage to prevent auto-login on refresh
                localStorage.removeItem('authToken');
                localStorage.removeItem('userId');
                localStorage.removeItem('userIsAdmin');
                localStorage.removeItem('lastCustomerEmail');
                localStorage.removeItem('lastCustomerFirstName');
                localStorage.removeItem('lastCustomerLastName');
                localStorage.removeItem('lastCustomerPhone');
                localStorage.removeItem('lastCustomerAddress');
                localStorage.removeItem('lastCustomerCity');
                localStorage.removeItem('lastCustomerCountry');
                localStorage.removeItem('lastCustomerPostcode');
                localStorage.removeItem('customerErrands');
                cache.clearAll();
                setUser(null);
                setAuthModalOpen(false);
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(220, 38, 38, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              {isCapacitor ? '🚪 Exit' : 'Logout'}
            </button>
          ) : (
            <>
              <button
                style={{ ...buttonStyle, background: "#2563eb", color: "#fff" }}
                onClick={switchToSignupMode}
              >
                Sign Up
              </button>
              <button
                style={{ ...buttonStyle, background: "#f3f4f6", color: "#2563eb" }}
                onClick={() => { setAuthMode('login'); setAuthModalOpen(true); }}
              >
                Login
              </button>
            </>
          )}
        </div>
      </header>
      
      {/* User Details Modal */}
      {userDetailsOpen && user && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.5)', zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background 0.3s', padding: '20px' }}>
          <div style={{ background: '#fff', borderRadius: 20, padding: '40px 20px', width: '100%', maxWidth: 500, boxShadow: '0 12px 40px rgba(0,0,0,0.15)', position: 'relative', animation: 'fadeInModal 0.35s', boxSizing: 'border-box' }}>
            <button 
              onClick={() => setUserDetailsOpen(false)} 
              style={{ position: 'absolute', top: 16, right: 16, background: 'none', border: 'none', fontSize: 28, cursor: 'pointer', color: '#999', transition: 'color 0.2s' }}
              onMouseEnter={(e) => e.target.style.color = '#2563eb'}
              onMouseLeave={(e) => e.target.style.color = '#999'}
            >
              ×
            </button>
            
            {/* Header with Profile Image */}
            <div style={{ textAlign: 'center', marginBottom: 28 }}>
              <div style={{ position: 'relative', display: 'inline-block', marginBottom: 16 }}>
                <div style={{ 
                  width: 120, 
                  height: 120, 
                  borderRadius: '50%', 
                  background: profileImage ? '#fff' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 48,
                  position: 'relative',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                  overflow: 'hidden'
                }}>
                  {profileImage ? (
                    <img src={profileImage} alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    '👤'
                  )}
                </div>
                
                {/* Image Upload Button */}
                <label 
                  htmlFor="profileImageInput"
                  style={{ 
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                    background: '#2563eb',
                    color: '#fff',
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    fontSize: 20,
                    border: '3px solid #fff',
                    boxShadow: '0 4px 12px rgba(37, 99, 235, 0.3)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#1d4ed8';
                    e.currentTarget.style.transform = 'scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = '#2563eb';
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  �
                </label>
                <input 
                  id="profileImageInput"
                  type="file" 
                  accept="image/*"
                  onChange={handleProfileImageUpload}
                  style={{ display: 'none' }}
                />
              </div>
              
              <h2 style={{ fontWeight: 700, fontSize: 26, marginBottom: 4, color: '#1f2937' }}>
                {user.firstName} {user.lastName}
              </h2>
              <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 0 }}>Customer Profile</p>
            </div>
            
            {/* Details Card - Single Line Clean Format */}
            <div style={{ background: '#f9fafb', borderRadius: 14, padding: 20, marginBottom: 20 }}>
              {/* Email */}
              <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  📧 Email
                </div>
                <p style={{ fontSize: 14, color: '#1f2937', margin: 0, fontWeight: 500 }}>
                  {user.email || 'Not provided'}
                </p>
              </div>
              
              {/* Phone */}
              <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  📞 Phone
                </div>
                <p style={{ fontSize: 14, color: '#1f2937', margin: 0, fontWeight: 500 }}>
                  {user.phone || 'Not provided'}
                </p>
              </div>
              
              {/* Address */}
              <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  📍 Address
                </div>
                <p style={{ fontSize: 14, color: '#1f2937', margin: 0, fontWeight: 500 }}>
                  {user.address || 'Not provided'}
                </p>
              </div>
              
              {/* City */}
              <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  🏙️ City
                </div>
                <p style={{ fontSize: 14, color: '#1f2937', margin: 0, fontWeight: 500 }}>
                  {user.city || 'Not provided'}
                </p>
              </div>
              
              {/* Country */}
              <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  🌍 Country
                </div>
                <p style={{ fontSize: 14, color: '#1f2937', margin: 0, fontWeight: 500 }}>
                  {user.country || 'Not provided'}
                </p>
              </div>
              
              {/* Zip/Postcode */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  📮 Zip/Postcode
                </div>
                <p style={{ fontSize: 14, color: '#1f2937', margin: 0, fontWeight: 500 }}>
                  {user.postcode || 'Not provided'}
                </p>
              </div>
            </div>
            
            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: 10 }}>
              <button
                onClick={() => setUserDetailsOpen(false)}
                style={{
                  flex: 1,
                  background: '#2563eb',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 10,
                  padding: '12px 16px',
                  fontWeight: 600,
                  fontSize: 15,
                  cursor: 'pointer',
                  transition: 'background 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.background = '#1d4ed8'}
                onMouseLeave={(e) => e.target.style.background = '#2563eb'}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Puzzle Modal */}
      {puzzleOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#0007', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: '100%', maxWidth: 400, boxShadow: '0 4px 24px #0003', position: 'relative', boxSizing: 'border-box' }}>
            <button onClick={() => setPuzzleOpen(false)} style={{ position: 'absolute', top: 12, right: 16, background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#888' }}>&times;</button>
            <h3 style={{ fontWeight: 700, fontSize: 22, marginBottom: 12 }}>Puzzle Time!</h3>
            <div style={{ marginBottom: 16, fontSize: 17 }}>{PUZZLES[puzzleIdx].q}</div>
            <form onSubmit={handlePuzzleSubmit}>
              <input
                type="text"
                value={puzzleInput}
                onChange={e => setPuzzleInput(e.target.value)}
                disabled={puzzleShowAnswer}
                placeholder="Your answer..."
                style={{ width: '100%', padding: 8, fontSize: 16, borderRadius: 8, border: '1.5px solid #bfc2d9', marginBottom: 10 }}
              />
              <button type="submit" style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 18px', fontWeight: 600, fontSize: 16, cursor: 'pointer', marginRight: 8 }} disabled={puzzleShowAnswer}>Submit</button>
              <button type="button" style={{ background: '#f3f4f6', color: '#2563eb', border: 'none', borderRadius: 8, padding: '8px 18px', fontWeight: 600, fontSize: 16, cursor: 'pointer' }} onClick={handleNextPuzzle}>Next</button>
            </form>
            <div style={{ marginTop: 10, color: '#e74c3c', fontWeight: 600 }}>
              {puzzleShowAnswer && (
                <span>Answer: {PUZZLES[puzzleIdx].a}</span>
              )}
            </div>
            <div style={{ marginTop: 8, color: '#888', fontSize: 14 }}>Attempts: {puzzleAttempts} / 3</div>
          </div>
        </div>
      )}

      {/* Settings Modal */}
      {settingsOpen && !showChangePassword && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#0007', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', overflowY: 'auto' }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: '100%', maxWidth: 450, boxShadow: '0 4px 24px #0003', position: 'relative', boxSizing: 'border-box', margin: 'auto' }}>
            <button onClick={() => setSettingsOpen(false)} style={{ position: 'absolute', top: 12, right: 16, background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#888' }}>&times;</button>
            <h3 style={{ fontWeight: 700, fontSize: 22, marginBottom: 6 }}>⚙️ Account Settings</h3>
            <p style={{ fontSize: 13, color: '#666', marginBottom: 16 }}>Update your account information and security</p>
            <form onSubmit={handleSaveSettings}>
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontWeight: 600, fontSize: 13 }}>First Name</label>
                <input type="text" value={editFirstName} readOnly style={{ width: '100%', marginBottom: 8, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box', backgroundColor: '#f3f4f6', color: '#666', cursor: 'not-allowed' }} />
                <label style={{ fontWeight: 600, fontSize: 13 }}>Last Name</label>
                <input type="text" value={editLastName} readOnly style={{ width: '100%', marginBottom: 8, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box', backgroundColor: '#f3f4f6', color: '#666', cursor: 'not-allowed' }} />
                <label style={{ fontWeight: 600, fontSize: 13 }}>Email</label>
                <input type="email" value={editEmail} onChange={e => setEditEmail(e.target.value)} style={{ width: '100%', marginBottom: 8, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} required />
                <label style={{ fontWeight: 600, fontSize: 13 }}>Phone</label>
                <input type="tel" value={editPhone} onChange={e => setEditPhone(e.target.value)} style={{ width: '100%', marginBottom: 8, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} />
                <label style={{ fontWeight: 600, fontSize: 13 }}>Address</label>
                <input type="text" value={editAddress} onChange={e => setEditAddress(e.target.value)} style={{ width: '100%', marginBottom: 8, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} placeholder="Street address" />
                <label style={{ fontWeight: 600, fontSize: 13 }}>City</label>
                <input type="text" value={editCity} onChange={e => setEditCity(e.target.value)} style={{ width: '100%', marginBottom: 8, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} required />
                <label style={{ fontWeight: 600, fontSize: 13 }}>Country</label>
                <input type="text" value={editCountry} onChange={e => setEditCountry(e.target.value)} style={{ width: '100%', marginBottom: 8, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} required />
                <label style={{ fontWeight: 600, fontSize: 13 }}>Zip/Postcode</label>
                <input type="text" value={editPostcode} onChange={e => setEditPostcode(e.target.value)} style={{ width: '100%', marginBottom: 12, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} required />
              </div>
              <button type="submit" style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 0', fontWeight: 600, fontSize: 16, width: '100%', marginBottom: 8, cursor: 'pointer' }}>💾 Save Changes</button>
            </form>
            <button onClick={() => setShowChangePassword(true)} style={{ background: '#f3f4f6', color: '#2563eb', border: 'none', borderRadius: 8, padding: '10px 0', fontWeight: 600, fontSize: 14, width: '100%', marginBottom: 8, cursor: 'pointer' }}>🔐 Change Password</button>
            <button onClick={handleDeactivateAccount} style={{ background: '#fee2e2', color: '#dc2626', border: 'none', borderRadius: 8, padding: '10px 0', fontWeight: 600, fontSize: 14, width: '100%', cursor: 'pointer' }}>🗑️ Deactivate Account</button>
          </div>
        </div>
      )}

      {/* Change Password Modal */}
      {settingsOpen && showChangePassword && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#0007', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', overflowY: 'auto' }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: '100%', maxWidth: 450, boxShadow: '0 4px 24px #0003', position: 'relative', boxSizing: 'border-box', margin: 'auto' }}>
            <button onClick={() => setShowChangePassword(false)} style={{ position: 'absolute', top: 12, right: 16, background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#888' }}>&times;</button>
            <h3 style={{ fontWeight: 700, fontSize: 22, marginBottom: 12 }}>Change Password</h3>
            <form onSubmit={handleChangePassword}>
              {changePasswordError && <div style={{ color: '#dc2626', fontSize: 14, marginBottom: 12, padding: 10, background: '#fee2e2', borderRadius: 6 }}>{changePasswordError}</div>}
              {changePasswordSuccess && <div style={{ color: '#059669', fontSize: 14, marginBottom: 12, padding: 10, background: '#d1fae5', borderRadius: 6 }}>{changePasswordSuccess}</div>}
              
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontWeight: 600, fontSize: 13, display: 'block', marginBottom: 6 }}>Current Password</label>
                <div style={{ position: 'relative', marginBottom: 12 }}>
                  <input 
                    type={showCurrentPasswordField ? "text" : "password"} 
                    value={changePasswordCurrentPassword} 
                    onChange={e => setChangePasswordCurrentPassword(e.target.value)} 
                    placeholder="Enter current password"
                    style={{ width: '100%', padding: 10, paddingRight: 40, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} 
                    required 
                  />
                  <button 
                    type="button" 
                    style={{ position: 'absolute', right: 12, top: 10, background: 'none', border: 'none', color: '#2563eb', fontWeight: 600, cursor: 'pointer', fontSize: 13 }} 
                    onClick={() => setShowCurrentPasswordField(v => !v)}
                  >
                    {showCurrentPasswordField ? 'Hide' : 'Show'}
                  </button>
                </div>
                
                <label style={{ fontWeight: 600, fontSize: 13, display: 'block', marginBottom: 6 }}>New Password</label>
                <div style={{ position: 'relative', marginBottom: 12 }}>
                  <input 
                    type={showNewPasswordField ? "text" : "password"} 
                    value={changePasswordNewPassword} 
                    onChange={e => setChangePasswordNewPassword(e.target.value)} 
                    placeholder="Enter new password (min 8 characters)"
                    style={{ width: '100%', padding: 10, paddingRight: 40, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} 
                    required 
                  />
                  <button 
                    type="button" 
                    style={{ position: 'absolute', right: 12, top: 10, background: 'none', border: 'none', color: '#2563eb', fontWeight: 600, cursor: 'pointer', fontSize: 13 }} 
                    onClick={() => setShowNewPasswordField(v => !v)}
                  >
                    {showNewPasswordField ? 'Hide' : 'Show'}
                  </button>
                </div>
                
                <label style={{ fontWeight: 600, fontSize: 13, display: 'block', marginBottom: 6 }}>Confirm Password</label>
                <div style={{ position: 'relative' }}>
                  <input 
                    type={showConfirmPasswordField ? "text" : "password"} 
                    value={changePasswordConfirmPassword} 
                    onChange={e => setChangePasswordConfirmPassword(e.target.value)} 
                    placeholder="Confirm new password"
                    style={{ width: '100%', padding: 10, paddingRight: 40, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} 
                    required 
                  />
                  <button 
                    type="button" 
                    style={{ position: 'absolute', right: 12, top: 10, background: 'none', border: 'none', color: '#2563eb', fontWeight: 600, cursor: 'pointer', fontSize: 13 }} 
                    onClick={() => setShowConfirmPasswordField(v => !v)}
                  >
                    {showConfirmPasswordField ? 'Hide' : 'Show'}
                  </button>
                </div>
              </div>
              
              <button type="submit" style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 0', fontWeight: 600, fontSize: 16, width: '100%', marginBottom: 8, cursor: 'pointer' }}>Update Password</button>
              <button type="button" onClick={() => setShowChangePassword(false)} style={{ background: '#f3f4f6', color: '#666', border: 'none', borderRadius: 8, padding: '10px 0', fontWeight: 600, fontSize: 14, width: '100%', cursor: 'pointer' }}>Cancel</button>
            </form>
          </div>
        </div>
      )}


      {/* Auth Modal */}
      {authModalOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#0007', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', overflowY: 'auto' }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: '100%', maxWidth: 450, boxShadow: '0 4px 24px #0003', position: 'relative', boxSizing: 'border-box', margin: 'auto' }}>
            <button onClick={() => { setAuthModalOpen(false); setResetPwMode(false); }} style={{ position: 'absolute', top: 12, right: 16, background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#888' }}>&times;</button>
            <h3 style={{ fontWeight: 700, fontSize: 22, marginBottom: 12 }}>
              {resetPwMode ? 'Reset Password' : (authMode === 'login' ? 'Login' : 'Sign Up')}
            </h3>
            <form onSubmit={handleAuthSubmit}>
              {resetPwMode ? (
                <>
                  <input type="email" value={resetPwEmail} onChange={e => setResetPwEmail(e.target.value)} placeholder="Enter your email" style={{ width: '100%', marginBottom: 12, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9' }} required />
                  <div style={{ marginBottom: 12 }}>
                    <label><input type="radio" checked={resetPwMethod === 'link'} onChange={() => setResetPwMethod('link')} /> Email link</label>
                    <label style={{ marginLeft: 16 }}><input type="radio" checked={resetPwMethod === 'otp'} onChange={() => setResetPwMethod('otp')} /> OTP</label>
                  </div>
                  {!resetPwOtpSent ? (
                    <button type="button" style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 0', fontWeight: 600, fontSize: 16, width: '100%', marginBottom: 8, cursor: 'pointer' }} onClick={() => {
                      setResetPwOtpSent(true);
                      if (resetPwMethod === 'otp') setResetPwOtp('123456');
                      // ...existing code...
                    }}>Send {resetPwMethod === 'otp' ? 'OTP' : 'Reset Link'}</button>
                  ) : resetPwMethod === 'otp' && !resetPwVerified ? (
                    <>
                      <input type="text" value={resetPwOtpInput} onChange={e => setResetPwOtpInput(e.target.value)} placeholder="Enter OTP" style={{ width: '100%', marginBottom: 12, padding: 8, borderRadius: 8, border: '1.5px solid #bfc2d9' }} required />
                      <button type="button" style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 0', fontWeight: 600, fontSize: 16, width: '100%', marginBottom: 8, cursor: 'pointer' }} onClick={() => {
                        if (resetPwOtpInput === resetPwOtp) { setResetPwVerified(true); } else { /* handle invalid OTP */ }
                      }}>Verify OTP</button>
                    </>
                  ) : (
                    <>
                      <div style={{ position: 'relative', marginBottom: 12 }}>
                        <input type={showPassword ? "text" : "password"} value={authPassword} onChange={e => setAuthPassword(e.target.value)} placeholder="New password" style={{ width: '100%', padding: 8, paddingRight: 40, borderRadius: 8, border: '1.5px solid #bfc2d9' }} required />
                        <button type="button" style={{ position: 'absolute', right: 10, top: 10, background: 'none', border: 'none', color: '#2563eb', fontWeight: 600, cursor: 'pointer', fontSize: 12 }} onClick={() => setShowPassword(v => !v)}>{showPassword ? 'Hide' : 'Show'}</button>
                      </div>
                      <button type="button" style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 0', fontWeight: 600, fontSize: 16, width: '100%', marginBottom: 8, cursor: 'pointer' }} onClick={() => {
                        // ...existing code...
                        setResetPwMode(false); setAuthModalOpen(false);
                        setResetPwOtpSent(false); setResetPwVerified(false); setResetPwOtpInput('');
                      }}>Reset Password</button>
                    </>
                  )}
                </>
              ) : (
                <>
                  {authMode === 'signup' && (
                    <>
                      <div style={{ marginBottom: 8 }}>
                        <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4, fontWeight: 500 }}>First Name <span style={{ color: '#d32f2f', fontWeight: 700 }}>*</span></label>
                        <input type="text" value={authFirstName} onChange={e => setAuthFirstName(e.target.value)} placeholder="e.g., John" style={{ width: '100%', padding: 10, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} required />
                      </div>
                      <div style={{ marginBottom: 8 }}>
                        <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4, fontWeight: 500 }}>Last Name <span style={{ color: '#d32f2f', fontWeight: 700 }}>*</span></label>
                        <input type="text" value={authLastName} onChange={e => setAuthLastName(e.target.value)} placeholder="e.g., Doe" style={{ width: '100%', padding: 10, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} required />
                      </div>
                      <div style={{ marginBottom: 8 }}>
                        <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4, fontWeight: 500 }}>Address Line <span style={{ color: '#d32f2f', fontWeight: 700 }}>*</span></label>
                        <input type="text" value={authAddressLine} onChange={e => setAuthAddressLine(e.target.value)} placeholder="e.g., 123 Main Street, Apt 4B" style={{ width: '100%', padding: 10, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} required />
                      </div>
                      <div style={{ marginBottom: 8 }}>
                        <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4, fontWeight: 500 }}>Address Line 2 <span style={{ color: '#999', fontSize: 11, fontWeight: 400 }}>(Optional)</span></label>
                        <input type="text" value={authAddressLine2} onChange={e => setAuthAddressLine2(e.target.value)} placeholder="e.g., Suite 100 (optional)" style={{ width: '100%', padding: 10, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} />
                      </div>
                      <div style={{ marginBottom: 8 }}>
                        <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4, fontWeight: 500 }}>City/Town <span style={{ color: '#d32f2f', fontWeight: 700 }}>*</span></label>
                        <input type="text" value={authCity} onChange={e => setAuthCity(e.target.value)} placeholder="e.g., Lagos" style={{ width: '100%', padding: 10, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} required />
                      </div>
                      <div style={{ marginBottom: 12 }}>
                        <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4, fontWeight: 500 }}>Zip/Postcode <span style={{ color: '#d32f2f', fontWeight: 700 }}>*</span></label>
                        <input type="text" value={authPostcode} onChange={e => setAuthPostcode(e.target.value)} placeholder="e.g., 10001" style={{ width: '100%', padding: 10, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} required />
                      </div>
                      <div style={{ marginBottom: 8 }}>
                        <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4, fontWeight: 500 }}>Country <span style={{ color: '#d32f2f', fontWeight: 700 }}>*</span></label>
                        <select value={authCountry} onChange={e => {
                          setAuthCountry(e.target.value);
                          const selectedCountry = COUNTRIES.find(c => c.name === e.target.value);
                          if (selectedCountry && !authPhone.startsWith(selectedCountry.phoneCode)) {
                            setAuthPhone(selectedCountry.phoneCode + ' ');
                          }
                        }} style={{ width: '100%', padding: 10, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box', background: '#fff', cursor: 'pointer' }} required>
                          <option value="" disabled>Select your country</option>
                          {COUNTRIES.map(country => (
                            <option key={country.code} value={country.name}>{country.flag} {country.name}</option>
                          ))}
                        </select>
                      </div>
                      <div style={{ marginBottom: 8 }}>
                        <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4, fontWeight: 500 }}>Phone Number <span style={{ color: '#d32f2f', fontWeight: 700 }}>*</span></label>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          {authCountry && (
                            <span style={{ fontSize: 20, minWidth: 30, textAlign: 'center' }}>
                              {COUNTRIES.find(c => c.name === authCountry)?.flag}
                            </span>
                          )}
                          <input type="tel" value={authPhone} onChange={e => setAuthPhone(e.target.value.replace(/[^\d+\-() ]/g, ''))} placeholder="Enter your number" style={{ flex: 1, padding: 10, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} required />
                        </div>
                      </div>
                    </>
                  )}
                  <div style={{ marginBottom: 8 }}>
                    <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4, fontWeight: 500 }}>Email <span style={{ color: '#d32f2f', fontWeight: 700 }}>*</span></label>
                    <input type="email" value={authEmail} onChange={e => setAuthEmail(e.target.value)} placeholder="your@email.com" style={{ width: '100%', padding: 10, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} required />
                  </div>
                  <div style={{ marginBottom: 12, position: 'relative' }}>
                    <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4, fontWeight: 500 }}>Password <span style={{ color: '#d32f2f', fontWeight: 700 }}>*</span></label>
                    <input type={showPassword ? "text" : "password"} value={authPassword} onChange={e => setAuthPassword(e.target.value)} placeholder="Secure password" style={{ width: '100%', padding: 10, borderRadius: 8, border: '1.5px solid #bfc2d9', fontSize: 14, boxSizing: 'border-box' }} required />
                    <button type="button" style={{ position: 'absolute', right: 12, top: 28, background: 'none', border: 'none', color: '#2563eb', fontWeight: 600, cursor: 'pointer', fontSize: 13 }} onClick={() => setShowPassword(v => !v)}>{showPassword ? 'Hide' : 'Show'}</button>
                  </div>
                  <button 
                    type="submit" 
                    style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, padding: '12px 0', fontWeight: 600, fontSize: 16, width: '100%', marginBottom: 8, cursor: 'pointer', transition: 'transform 0.3s ease' }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.05)';
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(37, 99, 235, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    {authMode === 'login' ? 'Login' : 'Sign Up'}
                  </button>
                  <button type="button" style={{ color: '#2563eb', fontWeight: 600, fontSize: 14, display: 'block', marginTop: 8, background: 'none', border: 'none', padding: 0, textAlign: 'left', cursor: 'pointer' }} onClick={() => setResetPwMode(true)}>Forgot password?</button>
                </>
              )}
            </form>
            <div style={{ textAlign: 'center', marginTop: 8 }}>
              {resetPwMode ? (
                <span>Remembered your password? <button type="button" style={{ color: '#2563eb', fontWeight: 600, background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => setResetPwMode(false)}>Back to Login</button></span>
              ) : authMode === 'login' ? (
                <>
                  <span>Don't have an account? <button type="button" style={{ color: '#2563eb', fontWeight: 600, background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={switchToSignupMode}>Sign Up</button></span><br />
                  <button type="button" style={{ color: '#2563eb', fontWeight: 600, fontSize: 14, background: 'none', border: 'none', padding: 0, textAlign: 'left', cursor: 'pointer' }} onClick={() => setResetPwMode(true)}>Forgot password?</button>
                </>
              ) : (
                <span>Already have an account? <button type="button" style={{ color: '#2563eb', fontWeight: 600, background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => setAuthMode('login')}>Login</button></span>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Email Verification Modal */}
      {showVerificationModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#0007', zIndex: 2001, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', overflowY: 'auto' }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: '100%', maxWidth: 450, boxShadow: '0 4px 24px #0003', position: 'relative', boxSizing: 'border-box', margin: 'auto' }}>
            <button onClick={() => { setShowVerificationModal(false); setVerificationCode(''); }} style={{ position: 'absolute', top: 12, right: 16, background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#888' }}>&times;</button>
            <h3 style={{ fontWeight: 700, fontSize: 22, marginBottom: 12 }}>Verify Your Email</h3>
            <p style={{ color: '#666', marginBottom: 16 }}>We sent a 6-digit confirmation code to:</p>
            <p style={{ fontWeight: 600, marginBottom: 16, color: '#333' }}>{pendingVerificationEmail}</p>
            
            <form onSubmit={handleVerifyEmail}>
              <input
                type="text"
                value={verificationCode}
                onChange={e => setVerificationCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="000000"
                maxLength="6"
                style={{ width: '100%', marginBottom: 12, padding: 12, fontSize: 18, borderRadius: 8, border: '1.5px solid #bfc2d9', textAlign: 'center', letterSpacing: 4, fontWeight: 600 }}
                required
              />
              {verificationError && <p style={{ color: '#dc2626', fontSize: 13, marginBottom: 12 }}>{verificationError}</p>}
              <button
                type="submit"
                style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, padding: '12px 0', fontWeight: 600, fontSize: 16, width: '100%', marginBottom: 8, cursor: 'pointer', transition: 'transform 0.3s ease' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(37, 99, 235, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                Verify Code
              </button>
              <button
                type="button"
                style={{ color: '#2563eb', fontWeight: 600, fontSize: 14, background: 'none', border: 'none', padding: 0, cursor: 'pointer', width: '100%', textAlign: 'center' }}
                onClick={handleResendVerificationCode}
              >
                Didn't receive code? Resend
              </button>
            </form>
            <p style={{ color: '#999', fontSize: 12, marginTop: 16, textAlign: 'center' }}>Code expires in 10 minutes</p>
          </div>
        </div>
      )}

      {/* Main Card */}
      <main style={{ width: '100%', maxWidth: 900, margin: "32px auto 0 auto", background: "#fff", borderRadius: 18, boxShadow: "0 2px 12px #0002", padding: '36px 20px', border: "1.5px solid #ececec", boxSizing: 'border-box' }}>
        
        {/* Authentication Gate - Show if user is NOT logged in */}
        {!user ? (
          <div style={{ textAlign: 'center', padding: '40px 20px' }}>
            <div style={{ fontSize: 56, marginBottom: 20 }}>🔒</div>
            <h2 style={{ fontWeight: 700, fontSize: 26, marginBottom: 12, color: '#1f2937' }}>Sign In to Create Errands</h2>
            <p style={{ fontSize: 16, color: '#6b7280', marginBottom: 8, lineHeight: 1.6 }}>
              Only registered customers can create and manage errands on ErrandBridge.
            </p>
            <p style={{ fontSize: 14, color: '#9ca3af', marginBottom: 28 }}>
              Sign up to get started or login if you already have an account.
            </p>
            
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginBottom: 20 }}>
              <button
                onClick={switchToSignupMode}
                style={{
                  background: '#2563eb',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 10,
                  padding: '14px 32px',
                  fontSize: 16,
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#1d4ed8';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#2563eb';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                ✨ Sign Up
              </button>
              <button
                onClick={() => { setAuthMode('login'); setAuthModalOpen(true); }}
                style={{
                  background: '#f3f4f6',
                  color: '#2563eb',
                  border: '2px solid #2563eb',
                  borderRadius: 10,
                  padding: '14px 32px',
                  fontSize: 16,
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#dbeafe';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#f3f4f6';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                🔑 Login
              </button>
            </div>

            {/* Benefits/Why Join Section */}
            <div style={{ 
              background: '#f0f9ff', 
              border: '1px solid #bfdbfe', 
              borderRadius: 12, 
              padding: 20, 
              marginTop: 32,
              textAlign: 'left'
            }}>
              <h3 style={{ fontSize: 16, fontWeight: 600, color: '#0c4a6e', marginBottom: 12 }}>Why Join ErrandBridge?</h3>
              <ul style={{ margin: 0, paddingLeft: 20, color: '#1f2937', fontSize: 14, lineHeight: 1.8 }}>
                <li style={{ marginBottom: 8 }}>✅ Securely send items from EU/US to Lagos</li>
                <li style={{ marginBottom: 8 }}>✅ Real-time tracking and proof of delivery</li>
                <li style={{ marginBottom: 8 }}>✅ Verified service providers</li>
                <li style={{ marginBottom: 8 }}>✅ Encrypted file storage for sensitive documents</li>
                <li>✅ Dedicated customer support 24/7</li>
              </ul>
            </div>
          </div>
        ) : (
          <>
            {/* Route & Features Buttons - Above Create Errand */}
            <div style={{ marginBottom: 24, marginLeft: '-20px', marginRight: '-20px', paddingLeft: '20px', paddingRight: '20px' }}>
              <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "nowrap", overflowX: "auto", paddingBottom: 8, scrollBehavior: 'smooth' }}>
                {[
                  "EU/US → Lagos",
                  "Proof-first",
                  "Data minimisation",
                  "Assisted resolution",
                  "No hidden fees",
                  "Verified runners"
                ].map((label, idx) => (
                  <button
                    key={label}
                    style={{
                      background: "#2563eb",
                      color: "#fff",
                      border: "none",
                      borderRadius: 10,
                      padding: "8px 13px",
                      fontWeight: 600,
                      fontSize: "14px",
                      cursor: "pointer",
                      boxShadow: '0 2px 6px rgba(37, 99, 235, 0.2)',
                      transition: 'all 0.2s ease',
                      textDecoration: "none",
                      whiteSpace: 'nowrap',
                      flexShrink: 0
                    }}
                    onClick={() => handleToggleInfo(idx)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#1d4ed8';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = '#2563eb';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 2px 6px rgba(37, 99, 235, 0.2)';
                    }}
                  >
                    {label}
                  </button>
                ))}
              </div>
              <div style={{ color: "#666", fontSize: 14, lineHeight: 1.6, backgroundColor: '#f9fafb', padding: 12, borderRadius: 8, border: '1px solid #e5e7eb' }}>
                <strong style={{ color: '#1f2937' }}>Privacy notice (EU/UK/US):</strong> We apply data minimisation and purpose limitation. You can request deletion. Attachments are access-controlled and used solely to fulfil your errand.
              </div>
            </div>

            {/* Form Content - Only show if user IS logged in */}
            <h2 style={{ fontWeight: 700, fontSize: 22, marginBottom: 8 }}>Create a Diaspora Errand</h2>
            <div style={{ color: "#444", marginBottom: 16 }}>Choose a template, edit the details, and submit with proof expectations.</div>
        {/* Title */}
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontWeight: 600 }}>Title</label>
          <div style={{ display: "flex", gap: 8, alignItems: "flex-start", marginTop: 4 }}>
            <div style={{ flex: 1, position: "relative" }}>
              <input 
                type="text" 
                value={title} 
                onChange={e => setTitle(e.target.value)} 
                placeholder="Title" 
                style={{ 
                  width: "100%", 
                  padding: 10, 
                  fontSize: 16, 
                  borderRadius: 8, 
                  border: "1.5px solid #bfc2d9" 
                }} 
              />
              
              {/* Title suggestions dropdown */}
              {showTitleSuggestions && titleSuggestions.length > 0 && (
                <div style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  background: "#fff",
                  border: "1.5px solid #2563eb",
                  borderRadius: "8px",
                  marginTop: 4,
                  boxShadow: "0 8px 16px rgba(37, 99, 235, 0.15)",
                  zIndex: 100,
                  maxHeight: "280px",
                  overflowY: "auto"
                }}>
                  <div style={{ padding: "8px 4px" }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: "#666", padding: "8px 12px", borderBottom: "1px solid #e5e7eb" }}>
                      ✨ AI Suggestions ({titleSuggestions.length})
                    </div>
                    {titleSuggestions.map((suggestion, idx) => (
                      <button
                        key={idx}
                        onClick={() => {
                          setTitle(suggestion);
                          setShowTitleSuggestions(false);
                        }}
                        style={{
                          display: "block",
                          width: "100%",
                          padding: "12px",
                          textAlign: "left",
                          background: "#fff",
                          border: "none",
                          borderBottom: idx < titleSuggestions.length - 1 ? "1px solid #f3f4f6" : "none",
                          cursor: "pointer",
                          fontSize: 14,
                          transition: "all 0.2s ease",
                          color: "#333"
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#f0f9ff";
                          e.currentTarget.style.color = "#2563eb";
                          e.currentTarget.style.paddingLeft = "16px";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "#fff";
                          e.currentTarget.style.color = "#333";
                          e.currentTarget.style.paddingLeft = "12px";
                        }}
                      >
                        {suggestion}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
            
            {/* AI Title button */}
            <button 
              style={{ 
                background: titleLoading ? "#9ca3af" : "#2563eb", 
                color: "#fff", 
                border: "none", 
                borderRadius: 8, 
                padding: "10px 12px", 
                fontWeight: 600, 
                cursor: titleLoading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                transition: 'transform 0.3s ease',
                marginTop: 0,
                whiteSpace: "nowrap",
                fontSize: 14
              }} 
              onClick={handleAITitleSuggest}
              disabled={titleLoading}
              onMouseEnter={(e) => {
                if (!titleLoading) {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(37, 99, 235, 0.2)';
                }
              }}
              onMouseLeave={(e) => {
                if (!titleLoading) {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }
              }}
              title="Generate AI-powered title suggestions based on your description"
            >
              <span style={{ fontSize: 16 }}>✨</span>
              {titleLoading ? "..." : "Title"}
            </button>
          </div>
          <div style={{ color: "#888", fontSize: 13, marginTop: 2 }}>Keep it short and specific (e.g., "Pick up passport from Ikeja office"). Click ✨ Title for AI suggestions!</div>
        </div>

        {/* Template */}
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontWeight: 600 }}>Template:</label>
          <select 
            value={template} 
            onChange={handleTemplateChange} 
            style={{ 
              marginLeft: 8, 
              padding: 6, 
              borderRadius: 8, 
              border: templateJustChanged ? "2px solid #10b981" : "1.5px solid #bfc2d9",
              backgroundColor: templateJustChanged ? "#dcfce7" : "#fff",
              transition: "all 0.3s ease",
              fontWeight: templateJustChanged ? 600 : 400,
              boxShadow: templateJustChanged ? "0 0 0 3px rgba(16, 185, 129, 0.1)" : "none"
            }}
          >
            <option>Official Document / Office Pickup</option>
            <option>Bank Transaction</option>
            <option>Medical / Pharmacy Pickup</option>
            <option>Government Office / Immigration</option>
            <option>Hotel / Hospitality</option>
            <option>International Parcel</option>
            <option>Legal / Notary</option>
            <option>Corporate Logistics</option>
            <option>Personal Delivery</option>
            <option>Other</option>
          </select>
          <button 
            style={{ marginLeft: 8, padding: "6px 12px", borderRadius: 8, border: "1.5px solid #bfc2d9", background: "#fff", fontWeight: 600, cursor: "pointer", transition: 'transform 0.3s ease' }} 
            onClick={handleResetTemplate}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(37, 99, 235, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Reset template
          </button>
          <button 
            style={{ marginLeft: 8, padding: "6px 12px", borderRadius: 8, border: "1.5px solid #bfc2d9", background: "#fff", fontWeight: 600, cursor: "pointer", transition: 'transform 0.3s ease' }} 
            onClick={handleClearTemplate}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(37, 99, 235, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Clear
          </button>
          <button 
            style={{ marginLeft: 8, background: "#2563eb", color: "#fff", border: "none", borderRadius: 8, padding: "6px 12px", fontWeight: 600, cursor: "pointer", transition: 'transform 0.3s ease' }} 
            onClick={handleUseSuggestion}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(37, 99, 235, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Use suggestion
          </button>
          <button 
            style={{ 
              marginLeft: 8, 
              background: aiLoading ? "#9ca3af" : "#10b981", 
              color: "#fff", 
              border: "none", 
              borderRadius: 8, 
              padding: "6px 12px", 
              fontWeight: 600, 
              cursor: aiLoading ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              transition: 'transform 0.3s ease'
            }} 
            onClick={handleAISuggest}
            disabled={aiLoading}
            onMouseEnter={(e) => {
              if (!aiLoading) {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.2)';
              }
            }}
            onMouseLeave={(e) => {
              if (!aiLoading) {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
              }
            }}
          >
            <span style={{ fontSize: 16 }}>✨</span> {aiLoading ? "Generating..." : "AI Enhance"}
          </button>
        </div>

        {/* Note */}
        <div style={{ marginBottom: 12 }}>
          <textarea value={note} onChange={e => setNote(e.target.value)} placeholder={"Write your errand note here.\nTip: start from the template and add:\n• Office/vendor name\n• Reference number\n• Pickup window\n• Who to call on delivery"} style={{ width: "100%", minHeight: 80, padding: 10, fontSize: 16, borderRadius: 8, border: "1.5px solid #bfc2d9" }} />
          {aiError && (
            <div style={{ color: "#dc2626", fontSize: 13, marginTop: 6, padding: 6, background: "#fee2e2", borderRadius: 6 }}>
              ⚠️ {aiError}
            </div>
          )}
          <div style={{ color: "#888", fontSize: 13, marginTop: 2 }}>Option B uses the backend suggest endpoint when available. It falls back to a local draft if needed.<br />What success looks like: clear contacts + landmark + pickup window, then proof (photo/receipt/scan) and a delivery call/message.</div>
        </div>

        {/* Sensitivity */}
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontWeight: 600 }}>Sensitivity level (optional)</label>
          <select value={sensitivity} onChange={e => setSensitivity(e.target.value)} style={{ marginLeft: 8, padding: 6, borderRadius: 8, border: "1.5px solid #bfc2d9" }}>
            <option>Sensitive (documents, money, medicine)</option>
            <option>Normal</option>
            <option>Fragile (electronics, glass, etc.)</option>
            <option>Perishable (food, flowers, etc.)</option>
            <option>Confidential (legal, personal, etc.)</option>
            <option>Bulk/Heavy</option>
            <option>Other</option>
          </select>
          <div style={{ color: "#888", fontSize: 13, marginTop: 2 }}>This helps later with verified local runner selection, dispute handling, and pricing tiers.</div>
        </div>

        {/* Locations */}
        <div style={{ display: "flex", gap: 16, marginBottom: 12 }}>
          <div style={{ flex: 1, position: "relative" }}>
            <label style={{ fontWeight: 600 }}>Pickup Location 📍</label>
            <input 
              type="text" 
              value={pickup} 
              onChange={e => handlePickupInput(e.target.value)}
              onFocus={() => pickup.length > 1 && setShowPickupSuggestions(pickupSuggestions.length > 0)}
              placeholder="e.g., Lagos, Nigeria" 
              style={{ 
                width: "100%", 
                marginTop: 4, 
                padding: 10, 
                fontSize: 16, 
                borderRadius: 8, 
                border: "1.5px solid #bfc2d9",
                position: "relative",
                zIndex: 10
              }} 
            />
            {/* Pickup location suggestions */}
            {showPickupSuggestions && pickupSuggestions.length > 0 && (
              <div style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                background: "#fff",
                border: "1.5px solid #667eea",
                borderRadius: "8px",
                marginTop: 2,
                boxShadow: "0 8px 16px rgba(102, 126, 234, 0.15)",
                zIndex: 100,
                maxHeight: "200px",
                overflowY: "auto"
              }}>
                {pickupSuggestions.map((suggestion, idx) => (
                  <button
                    key={idx}
                    onClick={() => selectPickupLocation(suggestion)}
                    style={{
                      display: "block",
                      width: "100%",
                      padding: "12px",
                      textAlign: "left",
                      background: "#fff",
                      border: "none",
                      borderBottom: idx < pickupSuggestions.length - 1 ? "1px solid #f3f4f6" : "none",
                      cursor: "pointer",
                      fontSize: 14,
                      transition: "all 0.2s ease",
                      color: "#333"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#f0f4ff";
                      e.currentTarget.style.color = "#667eea";
                      e.currentTarget.style.paddingLeft = "16px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "#fff";
                      e.currentTarget.style.color = "#333";
                      e.currentTarget.style.paddingLeft = "12px";
                    }}
                  >
                    📍 {suggestion}
                  </button>
                ))}
              </div>
            )}
          </div>
          <div style={{ flex: 1, position: "relative" }}>
            <label style={{ fontWeight: 600 }}>Dropoff Location 🎯</label>
            <input 
              type="text" 
              value={dropoff} 
              onChange={e => handleDropoffInput(e.target.value)}
              onFocus={() => dropoff.length > 1 && setShowDropoffSuggestions(dropoffSuggestions.length > 0)}
              placeholder="e.g., Abuja, Nigeria" 
              style={{ 
                width: "100%", 
                marginTop: 4, 
                padding: 10, 
                fontSize: 16, 
                borderRadius: 8, 
                border: "1.5px solid #bfc2d9",
                position: "relative",
                zIndex: 10
              }} 
            />
            {/* Dropoff location suggestions */}
            {showDropoffSuggestions && dropoffSuggestions.length > 0 && (
              <div style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                background: "#fff",
                border: "1.5px solid #667eea",
                borderRadius: "8px",
                marginTop: 2,
                boxShadow: "0 8px 16px rgba(102, 126, 234, 0.15)",
                zIndex: 100,
                maxHeight: "200px",
                overflowY: "auto"
              }}>
                {dropoffSuggestions.map((suggestion, idx) => (
                  <button
                    key={idx}
                    onClick={() => selectDropoffLocation(suggestion)}
                    style={{
                      display: "block",
                      width: "100%",
                      padding: "12px",
                      textAlign: "left",
                      background: "#fff",
                      border: "none",
                      borderBottom: idx < dropoffSuggestions.length - 1 ? "1px solid #f3f4f6" : "none",
                      cursor: "pointer",
                      fontSize: 14,
                      transition: "all 0.2s ease",
                      color: "#333"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#f0f4ff";
                      e.currentTarget.style.color = "#667eea";
                      e.currentTarget.style.paddingLeft = "16px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "#fff";
                      e.currentTarget.style.color = "#333";
                      e.currentTarget.style.paddingLeft = "12px";
                    }}
                  >
                    🎯 {suggestion}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>


        {/* Pickup Time Slot */}
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontWeight: 600 }}>📅 Preferred Pickup Time Slot</label>
          <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 13, color: "#666" }}>Date</label>
              <input 
                type="date" 
                value={pickupTimeSlotDate}
                onChange={e => setPickupTimeSlotDate(e.target.value)}
                style={{ 
                  width: "100%", 
                  marginTop: 4, 
                  padding: 10, 
                  fontSize: 16, 
                  borderRadius: 8, 
                  border: "1.5px solid #bfc2d9",
                  boxSizing: "border-box"
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 13, color: "#666" }}>From Time</label>
              <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
                <select 
                  value={pickupTimeSlotStart.split(":")[0] || ""}
                  onChange={e => {
                    const hour = e.target.value;
                    const minute = pickupTimeSlotStart.split(":")[1] || "00";
                    setPickupTimeSlotStart(hour && minute ? `${hour.padStart(2, "0")}:${minute}` : "");
                  }}
                  style={{ 
                    flex: 1,
                    padding: 10, 
                    fontSize: 16, 
                    borderRadius: 12, 
                    border: "1.5px solid #bfc2d9",
                    cursor: "pointer"
                  }}
                >
                  <option value="">Hour</option>
                  {Array.from({ length: 24 }, (_, i) => i).map(h => (
                    <option key={h} value={String(h).padStart(2, "0")}>
                      {String(h).padStart(2, "0")}
                    </option>
                  ))}
                </select>
                <select 
                  value={pickupTimeSlotStart.split(":")[1] || ""}
                  onChange={e => {
                    const hour = pickupTimeSlotStart.split(":")[0] || "00";
                    const minute = e.target.value;
                    setPickupTimeSlotStart(hour && minute ? `${hour}:${minute.padStart(2, "0")}` : "");
                  }}
                  style={{ 
                    flex: 1,
                    padding: 10, 
                    fontSize: 16, 
                    borderRadius: 12, 
                    border: "1.5px solid #bfc2d9",
                    cursor: "pointer"
                  }}
                >
                  <option value="">Min</option>
                  {["00", "15", "30", "45"].map(m => (
                    <option key={m} value={m}>
                      {m}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 13, color: "#666" }}>To Time</label>
              <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
                <select 
                  value={pickupTimeSlotEnd.split(":")[0] || ""}
                  onChange={e => {
                    const hour = e.target.value;
                    const minute = pickupTimeSlotEnd.split(":")[1] || "00";
                    setPickupTimeSlotEnd(hour && minute ? `${hour.padStart(2, "0")}:${minute}` : "");
                  }}
                  style={{ 
                    flex: 1,
                    padding: 10, 
                    fontSize: 16, 
                    borderRadius: 12, 
                    border: "1.5px solid #bfc2d9",
                    cursor: "pointer"
                  }}
                >
                  <option value="">Hour</option>
                  {Array.from({ length: 24 }, (_, i) => i).map(h => (
                    <option key={h} value={String(h).padStart(2, "0")}>
                      {String(h).padStart(2, "0")}
                    </option>
                  ))}
                </select>
                <select 
                  value={pickupTimeSlotEnd.split(":")[1] || ""}
                  onChange={e => {
                    const hour = pickupTimeSlotEnd.split(":")[0] || "00";
                    const minute = e.target.value;
                    setPickupTimeSlotEnd(hour && minute ? `${hour}:${minute.padStart(2, "0")}` : "");
                  }}
                  style={{ 
                    flex: 1,
                    padding: 10, 
                    fontSize: 16, 
                    borderRadius: 12, 
                    border: "1.5px solid #bfc2d9",
                    cursor: "pointer"
                  }}
                >
                  <option value="">Min</option>
                  {["00", "15", "30", "45"].map(m => (
                    <option key={m} value={m}>
                      {m}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div style={{ color: "#888", fontSize: 13, marginTop: 6 }}>Optional: Specify when you'd prefer to pick up your errand</div>
        </div>

        {/* Attachments */}
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontWeight: 600 }}>Attachments (images/docs)</label>
          <input type="file" multiple style={{ display: "block", marginTop: 4, marginBottom: 4 }} ref={el => window.uploadedFilesInput = el} />
          <div style={{ color: "#888", fontSize: 13 }}>No files selected</div>
          <div style={{ color: "#888", fontSize: 13, marginTop: 2 }}>Upload photos or documents only when required. Files are encrypted, access-restricted, and used solely for errand completion. Attachments are removed after the errand is closed.<br />Proof checklist: photo at pickup • receipt or document scan • message/call on delivery.<br />Post-submit: we create the errand first, then upload your files in the background (if upload fails, your errand is still saved).</div>

        {/* Contact Information Button */}
        <div style={{ marginTop: 16, marginBottom: 16 }}>
          <button
            type="button"
            onClick={() => setShowContactModal(true)}
            style={{
              background: "#f0f9ff",
              border: "1px solid #bfdbfe",
              borderRadius: 8,
              padding: "10px 16px",
              fontSize: 14,
              fontWeight: 600,
              color: "#0c4a6e",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 8,
              transition: "background-color 0.2s ease"
            }}
            onMouseEnter={(e) => e.target.style.background = "#e0f2fe"}
            onMouseLeave={(e) => e.target.style.background = "#f0f9ff"}
          >
            <span>📞</span> Contact & Support
          </button>
        </div>

          <div style={{ margin: "16px 0", display: "flex", alignItems: "center", gap: 8 }}>
            <input type="checkbox" checked={agreed} onChange={e => setAgreed(e.target.checked)} style={{ width: 24, height: 24 }} />
            <span style={{ fontSize: 15 }}>I confirm I've read and agree to the <button type="button" onClick={() => setShowPolicyModal(true)} style={{ color: "#2563eb", fontWeight: 600, background: 'none', border: 'none', padding: 0, cursor: 'pointer', textDecoration: 'underline' }}>Terms-lite pilot policy</button>.</span>
          </div>
          <div style={{ color: "#888", fontSize: 13, marginBottom: 8 }}>Especially for sensitive errands: don’t upload documents unless necessary.</div>
        </div>

        {/* Submit Button */}
  <button
    style={{
      background: (!title || !agreed) ? "#8fa8f8" : "#2563eb",
      color: "#fff",
      border: "none",
      borderRadius: 8,
      padding: "12px 0",
      fontWeight: 700,
      fontSize: 18,
      width: 180,
      marginBottom: 18,
      cursor: (!title || !agreed) ? "not-allowed" : "pointer",
      boxShadow: (!title || !agreed) ? "none" : "0 2px 12px #2563eb44",
      transition: "background 0.2s, box-shadow 0.2s, transform 0.3s ease"
    }}
    disabled={!title || !agreed}
    onClick={handleSubmitErrand}
    onMouseEnter={(e) => {
      if (!(!title || !agreed)) {
        e.currentTarget.style.transform = 'scale(1.05)';
        e.currentTarget.style.boxShadow = '0 4px 16px rgba(37, 99, 235, 0.3)';
      }
    }}
    onMouseLeave={(e) => {
      if (!(!title || !agreed)) {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 2px 12px #2563eb44';
      }
    }}
  >
    Submit Errand
  </button>

        {/* Before you submit warning */}
        {!title && (
          <div style={{ background: "#eaf0fb", color: "#2563eb", borderRadius: 10, padding: 16, marginBottom: 18, fontWeight: 600, fontSize: 17 }}>
            Before you submit<br /><span style={{ fontWeight: 400, fontSize: 15 }}>Add a title to enable submit.</span>
          </div>
        )}

        {/* Transparency section */}
        <div style={{ background: "#fafbfc", borderRadius: 12, padding: 18, marginBottom: 18, border: "1.5px solid #ececec", display: "flex", flexDirection: "column", gap: 8 }}>
          <div style={{ fontWeight: 700, fontSize: 18 }}>Your Transparency</div>
          <div style={{ display: "flex", gap: 24, alignItems: "flex-start", flexWrap: "wrap" }}>
            {/* Completed Errands */}
            <div style={{ display: "flex", alignItems: "center", gap: 12, padding: 12, background: "#fff", borderRadius: 8, border: "1px solid #e0e0e0" }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: 32, color: "#16a34a" }}>{transparencyData.completed_errands}</div>
                <div style={{ color: "#666", fontSize: 12, whiteSpace: "nowrap" }}>Completed Errands</div>
              </div>
            </div>
            
            {/* Documents Handled */}
            <div style={{ display: "flex", alignItems: "center", gap: 12, padding: 12, background: "#fff", borderRadius: 8, border: "1px solid #e0e0e0" }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: 32, color: "#2563eb" }}>{transparencyData.documents_handled}</div>
                <div style={{ color: "#666", fontSize: 12, whiteSpace: "nowrap" }}>Documents Uploaded</div>
              </div>
            </div>
            
            {/* View All Documents Button */}
            {uploadedFiles.length > 0 && (
              <button 
                style={{ marginLeft: "auto", border: "1.5px solid #2563eb", borderRadius: 8, padding: "8px 16px", background: "#fff", color: "#2563eb", fontWeight: 600, cursor: "pointer", transition: 'transform 0.3s ease' }} 
                onClick={() => setDetailsModal({ open: true, errand: null, transparency: true })}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(37, 99, 235, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                📁 View All Documents
              </button>
            )}
          </div>
          <div style={{ color: "#666", fontSize: 12, marginTop: 8 }}>
            ℹ️ Your transparency counts reflect all errands and document attachments in your account. These are used for verification and audit purposes.
          </div>
        </div>

        {/* Your Errands section */}
        <div data-section="my-errands" style={{ background: "#fafbfc", borderRadius: 12, padding: 18, border: "1.5px solid #ececec", marginBottom: 8 }}>
          <div style={{ fontWeight: 700, fontSize: 20, marginBottom: errandsSectionMinimized ? 0 : 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              📋 Your Errands ({errands.length})
              {isRefreshing && <span style={{ animation: 'spin 1s linear infinite', display: 'inline-block' }}>🔄</span>}
            </span>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              {selectedErrands.length > 0 && (
                <button 
                  style={{ background: '#dc2626', color: '#fff', border: 'none', borderRadius: 8, padding: '6px 12px', fontWeight: 600, cursor: 'pointer', fontSize: 14, transition: 'transform 0.3s ease' }} 
                  onClick={handleDeleteSelected}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(220, 38, 38, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  🗑️ Delete {selectedErrands.length} Selected
                </button>
              )}
              <button 
                onClick={() => setErrandsSectionMinimized(!errandsSectionMinimized)}
                style={{ 
                  background: '#e5e7eb', 
                  border: 'none', 
                  borderRadius: 6, 
                  padding: '4px 8px', 
                  cursor: 'pointer',
                  fontWeight: 600,
                  fontSize: 12,
                  color: '#374151',
                  transition: 'transform 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                {errandsSectionMinimized ? '📈 Expand' : '📉 Collapse'}
              </button>
            </div>
          </div>
          
          {!errandsSectionMinimized && (
            <>
          {errands.length === 0 ? (
            <div style={{ color: "#666", fontSize: 14, padding: 20, textAlign: 'center', background: '#fff', borderRadius: 8 }}>
              📭 No errands yet. Create one to get started!
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {/* Select All Header */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 12, background: '#f9fafb', borderRadius: 8, border: '1px solid #e5e7eb' }}>
                <input 
                  type="checkbox" 
                  checked={selectAll} 
                  onChange={handleSelectAll}
                  style={{ cursor: 'pointer', width: 18, height: 18 }}
                />
                <span style={{ fontWeight: 600, color: '#374151', fontSize: 14 }}>
                  Select All ({selectedErrands.length}/{errands.length})
                </span>
              </div>
              
              {errands.map(e => {
                const isExpanded = expandedErrandId === e.id;
                const statusBadge = getStatusBadge(e.status);
                return (
                  <div key={e.id} style={{ border: '1px solid #ddd', borderRadius: 8, overflow: 'hidden', background: '#fff' }}>
                    {/* Main Row */}
                    <div 
                      style={{
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 12, 
                        padding: 12, 
                        background: isExpanded ? '#f0f9ff' : '#fff',
                        borderBottom: isExpanded ? '1px solid #ddd' : 'none',
                        transition: 'background 0.2s'
                      }}
                    >
                      {/* Checkbox */}
                      <input 
                        type="checkbox" 
                        checked={selectedErrands.includes(e.id)} 
                        onChange={(evt) => {
                          evt.stopPropagation();
                          handleSelectErrand(e.id);
                        }}
                        style={{ cursor: 'pointer' }}
                      />
                      
                      {/* Expand/Collapse Icon - Only clickable */}
                      <button
                        onClick={() => setExpandedErrandId(isExpanded ? null : e.id)}
                        style={{ 
                          fontSize: 18, 
                          minWidth: 20,
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          padding: 0,
                          color: '#666'
                        }}
                      >
                        {isExpanded ? '▼' : '▶'}
                      </button>
                      
                      {/* Reference # */}
                      <div style={{ fontFamily: 'monospace', fontSize: 12, color: '#666', minWidth: 100 }}>
                        {e.referenceNumber}
                      </div>
                      
                      {/* Title */}
                      <div style={{ fontWeight: 600, flex: 1, minWidth: 150 }}>
                        {e.title}
                      </div>
                      
                      {/* Status Badge */}
                      <div style={{
                        background: statusBadge.bg,
                        color: statusBadge.color,
                        padding: '4px 10px',
                        borderRadius: 6,
                        fontSize: 12,
                        fontWeight: 600,
                        whiteSpace: 'nowrap',
                        minWidth: 110,
                        textAlign: 'center'
                      }}>
                        {statusBadge.icon} {e.status.charAt(0).toUpperCase() + e.status.slice(1)}
                      </div>
                      
                      {/* Created Date */}
                      <div style={{ fontSize: 12, color: '#666', minWidth: 140, textAlign: 'right' }}>
                        {e.createdAt ? new Date(e.createdAt).toLocaleDateString() : ''}
                      </div>
                      
                      {/* Action Buttons */}
                      {/* Show Assign button for admin when status is submitted */}
                      {userIsAdmin && e.status === 'submitted' && (
                        <button 
                          onClick={(evt) => {
                            evt.stopPropagation();
                            handleAssignErrand(e.id);
                          }}
                          style={{ 
                            background: '#8b5cf6', 
                            color: '#fff', 
                            border: 'none', 
                            borderRadius: 6, 
                            padding: '4px 10px', 
                            fontWeight: 600, 
                            cursor: 'pointer',
                            fontSize: 12,
                            transition: 'transform 0.3s ease',
                            marginRight: 8
                          }}
                          title="Assign this errand to yourself"
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(139, 92, 246, 0.2)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = 'none';
                          }}
                        >
                          👤 Assign
                        </button>
                      )}
                      
                      {/* Show Done button for admin/customer when status is assigned */}
                      {e.status === 'assigned' && (userIsAdmin || e.userId === parseInt(localStorage.getItem('userId'))) && (
                        <button 
                          onClick={(evt) => {
                            evt.stopPropagation();
                            handleMarkDone(e.id);
                          }}
                          style={{ 
                            background: '#10b981', 
                            color: '#fff', 
                            border: 'none', 
                            borderRadius: 6, 
                            padding: '4px 10px', 
                            fontWeight: 600, 
                            cursor: 'pointer',
                            fontSize: 12,
                            transition: 'transform 0.3s ease',
                            marginRight: 8
                          }}
                          title="Mark this errand as complete"
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.2)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = 'none';
                          }}
                        >
                          ✅ Done
                        </button>
                      )}
                      
                      {/* Show Accept button for customer when status is completed */}
                      {e.status === 'completed' && e.userId === parseInt(localStorage.getItem('userId')) && (
                        <button 
                          onClick={(evt) => {
                            evt.stopPropagation();
                            handleAcceptCompleteErrand(e.id);
                          }}
                          style={{ 
                            background: '#059669', 
                            color: '#fff', 
                            border: 'none', 
                            borderRadius: 6, 
                            padding: '4px 10px', 
                            fontWeight: 600, 
                            cursor: 'pointer',
                            fontSize: 12,
                            transition: 'transform 0.3s ease',
                            marginRight: 8
                          }}
                          title="Accept this completed errand"
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(5, 150, 105, 0.2)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = 'none';
                          }}
                        >
                          ✔️ Accept
                        </button>
                      )}
                      
                      <button 
                        onClick={(evt) => {
                          evt.stopPropagation();
                          handleEditErrand(e);
                        }}
                        style={{ 
                          background: '#2563eb', 
                          color: '#fff', 
                          border: 'none', 
                          borderRadius: 6, 
                          padding: '4px 10px', 
                          fontWeight: 600, 
                          cursor: 'pointer',
                          fontSize: 12,
                          transition: 'transform 0.3s ease',
                          marginRight: 8
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'scale(1.05)';
                          e.currentTarget.style.boxShadow = '0 2px 8px rgba(37, 99, 235, 0.2)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'scale(1)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        ✏️ Edit
                      </button>
                      <button 
                        onClick={(evt) => {
                          evt.stopPropagation();
                          handleDeleteErrand(e.id);
                        }}
                        style={{ 
                          background: '#dc2626', 
                          color: '#fff', 
                          border: 'none', 
                          borderRadius: 6, 
                          padding: '4px 10px', 
                          fontWeight: 600, 
                          cursor: 'pointer',
                          fontSize: 12,
                          transition: 'transform 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'scale(1.05)';
                          e.currentTarget.style.boxShadow = '0 2px 8px rgba(220, 38, 38, 0.2)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'scale(1)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        Delete
                      </button>
                    </div>
                    
                    {/* Expanded Details Section */}
                    {isExpanded && (
                      <div style={{ padding: 16, background: 'linear-gradient(135deg, #f5f7fa 0%, #fafbfc 100%)', borderTop: '1px solid #e5e7eb' }}>
                        {/* Assignment Status */}
                        {e.assignedTo && (
                          <div style={{ background: '#fef3c7', padding: 12, borderRadius: 10, marginBottom: 16, border: '1px solid #fcd34d' }}>
                            <div style={{ fontWeight: 700, color: '#92400e', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 6 }}>
                              <span>👤</span>
                              <span>Assignment Status</span>
                            </div>
                            <div style={{ color: '#78350f', fontSize: 12 }}>
                              Assigned to Admin (ID: {e.assignedTo})
                              {e.assignedAt && ` on ${new Date(e.assignedAt).toLocaleDateString()}`}
                            </div>
                          </div>
                        )}
                        
                        {/* Review Status */}
                        {e.reviewStatus && (
                          <div style={{ 
                            background: e.reviewStatus === 'reviewed' ? '#d1fae5' : '#f3e8ff',
                            padding: 12,
                            borderRadius: 10,
                            marginBottom: 16,
                            border: `1px solid ${e.reviewStatus === 'reviewed' ? '#a7f3d0' : '#e9d5ff'}`
                          }}>
                            <div style={{ fontWeight: 700, color: e.reviewStatus === 'reviewed' ? '#065f46' : '#6b21a8', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 6 }}>
                              <span>⭐</span>
                              <span>Customer Review</span>
                            </div>
                            {e.reviewStatus === 'reviewed' ? (
                              <div style={{ color: e.reviewStatus === 'reviewed' ? '#047857' : '#7e22ce', fontSize: 12 }}>
                                <div>Rating: {e.reviewerRating} / 5 ⭐</div>
                                {e.reviewerNotes && <div style={{ marginTop: 6 }}>{e.reviewerNotes}</div>}
                                {e.reviewCompletedAt && <div style={{ marginTop: 6, fontSize: 11, opacity: 0.8 }}>Reviewed on {new Date(e.reviewCompletedAt).toLocaleDateString()}</div>}
                              </div>
                            ) : (
                              <div style={{ color: '#7e22ce', fontSize: 12 }}>Pending customer review...</div>
                            )}
                          </div>
                        )}
                        
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, fontSize: 13, marginBottom: 16 }}>
                          <div style={{ background: '#fff', padding: 12, borderRadius: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                            <div style={{ fontWeight: 700, color: '#2563eb', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 6 }}>
                              <span>📍</span>
                              <span>Pickup Location</span>
                            </div>
                            <div style={{ color: '#333', lineHeight: '1.5', fontSize: 12 }}>{e.pickupLocation}</div>
                          </div>
                          <div style={{ background: '#fff', padding: 12, borderRadius: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                            <div style={{ fontWeight: 700, color: '#2563eb', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 6 }}>
                              <span>🎯</span>
                              <span>Dropoff Location</span>
                            </div>
                            <div style={{ color: '#333', lineHeight: '1.5', fontSize: 12 }}>{e.dropoffLocation}</div>
                          </div>
                          <div style={{ background: '#fff', padding: 12, borderRadius: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                            <div style={{ fontWeight: 700, color: '#dc2626', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 6 }}>
                              <span>⚠️</span>
                              <span>Sensitivity Level</span>
                            </div>
                            <div style={{ color: '#333', lineHeight: '1.5', fontSize: 12 }}>{e.sensitivity}</div>
                          </div>
                          <div style={{ background: '#fff', padding: 12, borderRadius: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                            <div style={{ fontWeight: 700, color: '#10b981', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 6 }}>
                              <span>📅</span>
                              <span>Created Date</span>
                            </div>
                            <div style={{ color: '#333', lineHeight: '1.5', fontSize: 12 }}>{e.createdAt ? new Date(e.createdAt).toLocaleString() : ''}</div>
                          </div>
                        </div>
                        
                        {/* Preferred Pickup Time Slot */}
                        {(e.pickupTimeSlotDate || e.pickupTimeSlotStart) && (
                          <div style={{ background: '#fff', padding: 12, borderRadius: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.05)', marginBottom: 16 }}>
                            <div style={{ fontWeight: 700, color: '#f59e0b', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 6 }}>
                              <span>⏰</span>
                              <span>Preferred Pickup Time</span>
                            </div>
                            <div style={{ color: '#333', lineHeight: '1.5', fontSize: 12 }}>
                              {e.pickupTimeSlotDate && new Date(e.pickupTimeSlotDate).toLocaleDateString()}
                              {e.pickupTimeSlotStart && ` • ${e.pickupTimeSlotStart}`}
                              {e.pickupTimeSlotEnd && ` - ${e.pickupTimeSlotEnd}`}
                            </div>
                          </div>
                        )}
                        
                        {/* Enhanced Notes with Flip Card */}
                        {e.note && (
                          <div style={{ marginTop: 16 }}>
                            <div style={{ 
                              perspective: '1000px',
                              position: 'relative',
                              minHeight: '140px'
                            }}>
                              <div 
                                style={{ 
                                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                  borderRadius: 12,
                                  padding: 16,
                                  color: '#fff',
                                  cursor: 'pointer',
                                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                  boxShadow: '0 4px 15px rgba(102, 126, 234, 0.2)',
                                  position: 'relative'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform = 'translateY(-4px) rotateX(5deg)';
                                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.35)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = 'translateY(0) rotateX(0)';
                                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.2)';
                                }}
                              >
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                                  <span style={{ fontSize: 24 }}>📝</span>
                                  <span style={{ fontWeight: 700, fontSize: 16, letterSpacing: '0.5px' }}>Notes</span>
                                </div>
                                <div style={{ 
                                  whiteSpace: 'pre-wrap', 
                                  fontSize: 14, 
                                  lineHeight: '1.6',
                                  color: '#f0f4ff',
                                  fontWeight: 500
                                }}>
                                  {e.note}
                                </div>
                                <div style={{ 
                                  marginTop: 10, 
                                  fontSize: 12, 
                                  color: '#d4d8ff',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 4
                                }}>
                                  <span>✨</span>
                                  <span>Click to see more details</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        
                        {/* Enhanced Status Timeline */}
                        {e.history && e.history.length > 0 && (
                          <div style={{ marginTop: 16 }}>
                            <div style={{ fontWeight: 700, fontSize: 14, color: '#1f2937', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
                              <span>⏱️</span>
                              <span>Activity Timeline</span>
                            </div>
                            <div style={{ 
                              borderLeft: '3px solid #667eea', 
                              paddingLeft: 16,
                              position: 'relative'
                            }}>
                              {e.history.map((h, idx) => {
                                const getStatusEmoji = (status) => {
                                  const emojiMap = {
                                    'submitted': '✅',
                                    'pending': '⏳',
                                    'in_progress': '🔄',
                                    'completed': '🎉',
                                    'failed': '❌',
                                    'cancelled': '🚫'
                                  };
                                  return emojiMap[status?.toLowerCase()] || '📌';
                                };
                                
                                return (
                                  <div key={idx} style={{ marginBottom: 14, position: 'relative' }}>
                                    <div style={{ 
                                      position: 'absolute',
                                      left: '-23px',
                                      top: '0px',
                                      width: '12px',
                                      height: '12px',
                                      background: '#667eea',
                                      borderRadius: '50%',
                                      border: '3px solid #fff'
                                    }} />
                                    <div style={{ background: '#fff', padding: 10, borderRadius: 8, boxShadow: '0 2px 6px rgba(0,0,0,0.05)', transition: 'all 0.3s ease' }}>
                                      <div style={{ fontWeight: 700, color: '#333', fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}>
                                        <span>{getStatusEmoji(h.newStatus)}</span>
                                        <span>{h.eventType}</span>
                                        <span style={{ color: '#667eea', fontWeight: 700 }}>→</span>
                                        <span style={{ color: '#667eea' }}>{h.newStatus?.charAt(0).toUpperCase() + h.newStatus?.slice(1)}</span>
                                      </div>
                                      <div style={{ color: '#666', fontSize: 12, marginTop: 4 }}>
                                        🕐 {h.createdAt ? new Date(h.createdAt).toLocaleString() : ''}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
            </>
          )}
        </div>
      {/* Details Modal for Errand or Transparency */}
      {detailsModal.open && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#0007', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', overflowY: 'auto' }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: '100%', maxWidth: 550, boxShadow: '0 4px 24px #0003', position: 'relative', boxSizing: 'border-box', margin: 'auto' }}>
            <button onClick={() => setDetailsModal({ open: false, errand: null })} style={{ position: 'absolute', top: 12, right: 16, background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#888' }}>&times;</button>
            {detailsModal.transparency ? (
              <>
                <h3 style={{ fontWeight: 700, fontSize: 22, marginBottom: 12 }}>All Uploaded Files</h3>
                {uploadedFiles.length === 0 ? <div>No files uploaded.</div> : (
                  <ul>
                    {uploadedFiles.map(f => (
                      <li key={f.id}><a href={f.url} target="_blank" rel="noopener noreferrer">{f.filename}</a></li>
                    ))}
                  </ul>
                )}
              </>
            ) : detailsModal.errand ? (
              <>
                <h3 style={{ fontWeight: 700, fontSize: 22, marginBottom: 12 }}>Errand Details</h3>
                <div><b>Reference:</b> {detailsModal.errand.referenceNumber}</div>
                <div><b>Title:</b> {detailsModal.errand.title}</div>
                <div><b>Status:</b> {detailsModal.errand.status}</div>
                <div><b>Pickup:</b> {detailsModal.errand.pickupLocation}</div>
                <div><b>Dropoff:</b> {detailsModal.errand.dropoffLocation}</div>
                <div><b>Sensitivity:</b> {detailsModal.errand.sensitivity}</div>
                <div><b>Created:</b> {detailsModal.errand.createdAt ? new Date(detailsModal.errand.createdAt).toLocaleString() : ''}</div>
                <div><b>Note:</b> <pre style={{ whiteSpace: 'pre-wrap', background: '#f7f7fa', padding: 8, borderRadius: 6 }}>{detailsModal.errand.note}</pre></div>
                {/* Errand History Timeline */}
                {detailsModal.errand.history && detailsModal.errand.history.length > 0 && (
                  <div style={{ marginTop: 18 }}>
                    <b>History:</b>
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                      {detailsModal.errand.history.map((h, idx) => (
                        <li key={idx} style={{ marginBottom: 6 }}>
                          <span style={{ fontWeight: 600 }}>{h.eventType.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</span>
                          {h.oldStatus && h.newStatus && (
                            <span style={{ marginLeft: 6, color: '#888' }}>({h.oldStatus} → {h.newStatus})</span>
                          )}
                          <span style={{ marginLeft: 8, color: '#2563eb' }}>{h.createdAt ? new Date(h.createdAt).toLocaleString() : ''}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </>
            ) : null}
          </div>
        </div>
      )}
          </>
        )}
      </main>

      {/* Info Modal */}
      {infoOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.32)', zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background 0.3s', animation: 'fadeInBg 0.3s', padding: '20px' }}>
          <div style={{ background: '#fff', borderRadius: 22, padding: '38px 24px 32px 24px', width: '100%', maxWidth: 480, boxShadow: '0 8px 32px #0004', position: 'relative', animation: 'fadeInModal 0.35s', boxSizing: 'border-box' }}>
            <button onClick={() => setInfoOpen(false)}
              style={{ position: 'absolute', top: 18, right: 22, background: 'none', border: 'none', fontSize: 28, cursor: 'pointer', color: '#2563eb', fontWeight: 700, borderRadius: '50%', width: 38, height: 38, lineHeight: '38px', textAlign: 'center', transition: 'background 0.2s' }}
              onMouseOver={e => e.currentTarget.style.background = '#f3f4f6'}
              onMouseOut={e => e.currentTarget.style.background = 'none'}
              aria-label="Close info dialog"
            >&times;</button>
            <div style={{ fontWeight: 800, fontSize: 22, marginBottom: 16, color: '#2563eb', letterSpacing: 0.2 }}>Info</div>
            <div style={{ color: '#222', fontSize: 16, lineHeight: 1.6, whiteSpace: 'pre-line' }}>{infoContent}</div>
          </div>
          <style>{`
            @keyframes fadeInModal { from { opacity: 0; transform: translateY(30px) scale(0.98); } to { opacity: 1; transform: none; } }
            @keyframes fadeInBg { from { opacity: 0; } to { opacity: 1; } }
          `}</style>
        </div>
      )}

      {/* Edit Errand Modal */}
      {editModalOpen && editingErrand && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.32)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'auto', padding: '20px' }}>
          <div style={{ background: '#fff', borderRadius: 22, padding: '38px 24px 32px 24px', width: '100%', maxWidth: 650, boxShadow: '0 8px 32px #0004', position: 'relative', margin: 'auto', boxSizing: 'border-box' }}>
            <button onClick={() => setEditModalOpen(false)}
              style={{ position: 'absolute', top: 18, right: 22, background: 'none', border: 'none', fontSize: 28, cursor: 'pointer', color: '#2563eb', fontWeight: 700, borderRadius: '50%', width: 38, height: 38, lineHeight: '38px', textAlign: 'center', transition: 'background 0.2s' }}
              onMouseOver={e => e.currentTarget.style.background = '#f3f4f6'}
              onMouseOut={e => e.currentTarget.style.background = 'none'}
              aria-label="Close edit dialog"
            >&times;</button>
            
            <div style={{ fontWeight: 800, fontSize: 22, marginBottom: 24, color: '#2563eb', display: 'flex', alignItems: 'center', gap: 8 }}>
              ✏️ Edit Errand
            </div>

            {/* Edit Form Fields */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 16, marginBottom: 24 }}>
              
              {/* Title */}
              <div>
                <label style={{ fontWeight: 600, fontSize: 13, color: '#2563eb', marginBottom: 6, display: 'block' }}>📝 Title *</label>
                <input
                  type="text"
                  value={editFormData.title || ''}
                  onChange={(e) => setEditFormData({ ...editFormData, title: e.target.value })}
                  placeholder="Enter errand title"
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #bfc2d9', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box' }}
                />
              </div>

              {/* Note/Description */}
              <div>
                <label style={{ fontWeight: 600, fontSize: 13, color: '#2563eb', marginBottom: 6, display: 'block' }}>📋 Description</label>
                <textarea
                  value={editFormData.note || ''}
                  onChange={(e) => setEditFormData({ ...editFormData, note: e.target.value })}
                  placeholder="Enter errand details"
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #bfc2d9', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box', minHeight: 80, resize: 'none' }}
                />
              </div>

              {/* Pickup Location */}
              <div>
                <label style={{ fontWeight: 600, fontSize: 13, color: '#2563eb', marginBottom: 6, display: 'block' }}>📍 Pickup Location *</label>
                <input
                  type="text"
                  value={editFormData.pickupLocation || ''}
                  onChange={(e) => setEditFormData({ ...editFormData, pickupLocation: e.target.value })}
                  placeholder="Enter pickup location"
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #bfc2d9', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box' }}
                />
              </div>

              {/* Dropoff Location */}
              <div>
                <label style={{ fontWeight: 600, fontSize: 13, color: '#2563eb', marginBottom: 6, display: 'block' }}>🎯 Dropoff Location *</label>
                <input
                  type="text"
                  value={editFormData.dropoffLocation || ''}
                  onChange={(e) => setEditFormData({ ...editFormData, dropoffLocation: e.target.value })}
                  placeholder="Enter dropoff location"
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #bfc2d9', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box' }}
                />
              </div>

              {/* Template Selection */}
              <div>
                <label style={{ fontWeight: 600, fontSize: 13, color: '#2563eb', marginBottom: 6, display: 'block' }}>🏷️ Template</label>
                <select
                  value={editFormData.template || 'Official Document / Office Pickup'}
                  onChange={(e) => setEditFormData({ ...editFormData, template: e.target.value })}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #bfc2d9', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box' }}
                >
                  <option>Official Document / Office Pickup</option>
                  <option>Grocery Delivery</option>
                  <option>Personal Item / Package Delivery</option>
                  <option>Laundry Delivery</option>
                  <option>Food Order Delivery</option>
                  <option>Bill Payment / Financial Transaction</option>
                  <option>Service Request</option>
                  <option>Meeting / Appointment Coordination</option>
                  <option>Medical / Prescription Delivery</option>
                  <option>Special Request</option>
                </select>
              </div>

              {/* Sensitivity */}
              <div>
                <label style={{ fontWeight: 600, fontSize: 13, color: '#2563eb', marginBottom: 6, display: 'block' }}>⚠️ Sensitivity</label>
                <select
                  value={editFormData.sensitivity || 'Sensitive (documents, money, medicine)'}
                  onChange={(e) => setEditFormData({ ...editFormData, sensitivity: e.target.value })}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #bfc2d9', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box' }}
                >
                  <option>Not Sensitive (general items)</option>
                  <option>Moderately Sensitive (electronics, valuables)</option>
                  <option>Sensitive (documents, money, medicine)</option>
                  <option>Highly Sensitive (confidential, fragile)</option>
                </select>
              </div>
            </div>

            {/* Buttons */}
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 24 }}>
              <button
                onClick={() => setEditModalOpen(false)}
                style={{ padding: '10px 20px', border: '1.5px solid #bfc2d9', background: '#fff', color: '#2563eb', borderRadius: 8, fontWeight: 600, cursor: 'pointer', transition: 'all 0.3s ease' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#f3f4f6';
                  e.currentTarget.style.transform = 'scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#fff';
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleSaveEdit}
                style={{ padding: '10px 20px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer', transition: 'all 0.3s ease' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#1d4ed8';
                  e.currentTarget.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#2563eb';
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              >
                💾 Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Contact Modal */}
      {showContactModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1001,
          padding: '20px'
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 12,
            padding: 28,
            width: '100%',
            maxWidth: 500,
            maxHeight: '80vh',
            overflowY: 'auto',
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
            boxSizing: 'border-box'
          }}>
            <h2 style={{ marginTop: 0, marginBottom: 8, fontSize: 22, color: '#1f2937', display: 'flex', alignItems: 'center', gap: 8 }}>
              <span>📞</span> Contact & Support
            </h2>
            <p style={{ color: '#6b7280', marginBottom: 20, fontSize: 14 }}>Have questions or need help? We're here for you!</p>

            <div style={{ fontSize: 14, color: '#374151', lineHeight: 1.8 }}>
              <div style={{ marginBottom: 18, paddingBottom: 18, borderBottom: '1px solid #e5e7eb' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <span style={{ fontSize: 20 }}>📧</span>
                  <div>
                    <p style={{ margin: '0 0 4px 0', fontWeight: 600, color: '#1f2937' }}>Email</p>
                    <p style={{ margin: 0, color: '#2563eb', wordBreak: 'break-all' }}>support@errandbridge.com</p>
                    <p style={{ margin: '4px 0 0 0', fontSize: 12, color: '#6b7280' }}>We respond within 24 hours</p>
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: 18, paddingBottom: 18, borderBottom: '1px solid #e5e7eb' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <span style={{ fontSize: 20 }}>💬</span>
                  <div>
                    <p style={{ margin: '0 0 4px 0', fontWeight: 600, color: '#1f2937' }}>Chat</p>
                    <p style={{ margin: 0, color: '#374151' }}>Available in the app during business hours</p>
                    <p style={{ margin: '4px 0 0 0', fontSize: 12, color: '#6b7280' }}>Real-time support for urgent issues</p>
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: 18, paddingBottom: 18, borderBottom: '1px solid #e5e7eb' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <span style={{ fontSize: 20 }}>📱</span>
                  <div>
                    <p style={{ margin: '0 0 4px 0', fontWeight: 600, color: '#1f2937' }}>Phone</p>
                    <p style={{ margin: 0, color: '#2563eb', fontWeight: 600 }}>+234 123 456 7890</p>
                    <p style={{ margin: '4px 0 0 0', fontSize: 12, color: '#6b7280' }}>For urgent matters</p>
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: 18 }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <span style={{ fontSize: 20 }}>🕐</span>
                  <div>
                    <p style={{ margin: '0 0 4px 0', fontWeight: 600, color: '#1f2937' }}>Business Hours</p>
                    <p style={{ margin: 0, color: '#374151' }}>Monday - Friday</p>
                    <p style={{ margin: '2px 0 0 0', color: '#374151' }}>9:00 AM - 6:00 PM (WAT)</p>
                    <p style={{ margin: '4px 0 0 0', fontSize: 12, color: '#6b7280' }}>*Closed on weekends and holidays</p>
                  </div>
                </div>
              </div>

              <div style={{ background: '#fff3cd', border: '1px solid #ffeeba', borderRadius: 8, padding: 12, marginTop: 20 }}>
                <p style={{ margin: 0, fontSize: 13, color: '#856404' }}>
                  <strong>Reporting a complaint?</strong> Please have your errand ID ready and provide details about the issue. Our support team will investigate and get back to you within 48 hours.
                </p>
              </div>
            </div>

            <button
              onClick={() => setShowContactModal(false)}
              style={{
                width: '100%',
                padding: '12px 16px',
                background: '#2563eb',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                cursor: 'pointer',
                fontWeight: 500,
                fontSize: 14,
                marginTop: 24,
                transition: 'background-color 0.2s ease'
              }}
              onMouseEnter={(e) => e.target.style.background = '#1d4ed8'}
              onMouseLeave={(e) => e.target.style.background = '#2563eb'}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Policy Modal */}
      {showPolicyModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          padding: '20px'
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 12,
            padding: 28,
            width: '100%',
            maxWidth: 600,
            maxHeight: '80vh',
            overflowY: 'auto',
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
            boxSizing: 'border-box'
          }}>
            <h2 style={{ marginTop: 0, marginBottom: 16, fontSize: 24, color: '#1f2937' }}>
              Terms-Lite Pilot Policy
            </h2>

            <div style={{ fontSize: 14, lineHeight: 1.6, color: '#374151' }}>
              <h3 style={{ marginTop: 16, marginBottom: 8, color: '#1f2937' }}>1. Service Overview</h3>
              <p>ErrandBridge is a pilot service that connects users with local service providers for various errands and tasks. This service is provided on an "as-is" basis during the pilot phase.</p>

              <h3 style={{ marginTop: 16, marginBottom: 8, color: '#1f2937' }}>2. User Responsibilities</h3>
              <p>Users agree to:</p>
              <ul style={{ marginTop: 8, marginBottom: 8 }}>
                <li>Provide accurate information when creating errands</li>
                <li>Not request illegal or harmful services</li>
                <li>Maintain confidentiality of sensitive documents</li>
                <li>Respect the service providers' time and professionalism</li>
              </ul>

              <h3 style={{ marginTop: 16, marginBottom: 8, color: '#1f2937' }}>3. Data & Privacy</h3>
              <p>All documents and attachments are encrypted and access-restricted. Files are removed after errand completion. Your personal information is used solely for service delivery and will not be shared with third parties.</p>

              <h3 style={{ marginTop: 16, marginBottom: 8, color: '#1f2937' }}>4. Limitation of Liability</h3>
              <p>ErrandBridge is not liable for delays, service failures, or loss of documents. Users are responsible for uploading sensitive documents at their own risk.</p>

              <h3 style={{ marginTop: 16, marginBottom: 8, color: '#1f2937' }}>5. Service Provider</h3>
              <p>Service providers are independent contractors. ErrandBridge does not guarantee specific completion times or outcomes but will work to resolve disputes fairly.</p>

              <h3 style={{ marginTop: 16, marginBottom: 8, color: '#1f2937' }}>6. Changes to Terms</h3>
              <p>These terms may be updated during the pilot phase. Continued use of the service indicates acceptance of updated terms.</p>

              <p style={{ marginTop: 24, fontSize: 12, color: '#6b7280' }}>Last updated: January 1, 2026</p>
            </div>

            <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
              <button
                onClick={() => setShowPolicyModal(false)}
                style={{
                  flex: 1,
                  padding: '10px 16px',
                  border: '1px solid #d1d5db',
                  background: '#f3f4f6',
                  borderRadius: 8,
                  cursor: 'pointer',
                  fontWeight: 500,
                  fontSize: 14
                }}
              >
                Close
              </button>
              <button
                onClick={() => {
                  setAgreed(true);
                  setShowPolicyModal(false);
                }}
                style={{
                  flex: 1,
                  padding: '10px 16px',
                  background: '#2563eb',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 8,
                  cursor: 'pointer',
                  fontWeight: 500,
                  fontSize: 14
                }}
              >
                I Accept & Agree
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Review Modal - Shows after errand completion */}
      {reviewModalOpen && reviewErrand && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#0007', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', overflowY: 'auto' }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: '100%', maxWidth: 550, boxShadow: '0 4px 24px #0003', position: 'relative', boxSizing: 'border-box', margin: 'auto' }}>
            <button onClick={() => { setReviewModalOpen(false); setReviewErrand(null); }} style={{ position: 'absolute', top: 12, right: 16, background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#888' }}>&times;</button>
            
            <h3 style={{ fontWeight: 700, fontSize: 24, marginBottom: 8, color: '#10b981' }}>🎉 Errand Completed!</h3>
            <p style={{ fontSize: 14, color: '#666', marginBottom: 20 }}>Thank you for using ErrandBridge. Please share your feedback about this errand.</p>
            
            <form onSubmit={(e) => { e.preventDefault(); handleSubmitReview(); }}>
              {/* Errand Details */}
              <div style={{ background: '#f3f4f6', padding: 12, borderRadius: 8, marginBottom: 20 }}>
                <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 4 }}>{reviewErrand.title}</div>
                <div style={{ fontSize: 12, color: '#666' }}>Reference: {reviewErrand.referenceNumber}</div>
              </div>
              
              {/* Rating */}
              <div style={{ marginBottom: 20 }}>
                <label style={{ fontWeight: 600, fontSize: 14, display: 'block', marginBottom: 10 }}>How would you rate this errand? ⭐</label>
                <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                  {[1, 2, 3, 4, 5].map(star => (
                    <button
                      key={star}
                      type="button"
                      onClick={() => setReviewRating(star)}
                      style={{
                        fontSize: 32,
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        opacity: star <= reviewRating ? 1 : 0.3,
                        transform: star <= reviewRating ? 'scale(1.1)' : 'scale(1)',
                        transition: 'all 0.2s'
                      }}
                      title={`${star} star${star !== 1 ? 's' : ''}`}
                    >
                      ⭐
                    </button>
                  ))}
                </div>
              </div>
              
              {/* Notes */}
              <div style={{ marginBottom: 20 }}>
                <label style={{ fontWeight: 600, fontSize: 14, display: 'block', marginBottom: 8 }}>Additional Comments (optional)</label>
                <textarea
                  value={reviewNotes}
                  onChange={(e) => setReviewNotes(e.target.value)}
                  placeholder="Tell us what you liked or what could be improved..."
                  maxLength="1000"
                  style={{
                    width: '100%',
                    padding: 12,
                    borderRadius: 8,
                    border: '1.5px solid #bfc2d9',
                    fontSize: 14,
                    fontFamily: 'inherit',
                    resize: 'vertical',
                    minHeight: '100px',
                    boxSizing: 'border-box'
                  }}
                />
                <div style={{ fontSize: 12, color: '#888', marginTop: 4, textAlign: 'right' }}>
                  {reviewNotes.length}/1000
                </div>
              </div>
              
              {/* Buttons */}
              <div style={{ display: 'flex', gap: 12 }}>
                <button
                  type="submit"
                  disabled={reviewSubmitting}
                  style={{
                    flex: 1,
                    background: '#10b981',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 8,
                    padding: '12px 16px',
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: reviewSubmitting ? 'not-allowed' : 'pointer',
                    opacity: reviewSubmitting ? 0.6 : 1,
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => !reviewSubmitting && (e.target.style.background = '#059669')}
                  onMouseLeave={(e) => !reviewSubmitting && (e.target.style.background = '#10b981')}
                >
                  {reviewSubmitting ? '⏳ Submitting...' : '✅ Submit Review'}
                </button>
                <button
                  type="button"
                  onClick={() => { setReviewModalOpen(false); setReviewErrand(null); }}
                  style={{
                    flex: 1,
                    background: '#f3f4f6',
                    color: '#666',
                    border: 'none',
                    borderRadius: 8,
                    padding: '12px 16px',
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: 'pointer',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.background = '#e5e7eb'}
                  onMouseLeave={(e) => e.target.style.background = '#f3f4f6'}
                >
                  Skip
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ✅ ERRAND SUBMISSION CONFIRMATION MODAL */}
      {submissionConfirmOpen && submittedErrandData && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#0007', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', overflowY: 'auto' }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 40, width: '100%', maxWidth: 550, boxShadow: '0 8px 32px #0003', textAlign: 'center', position: 'relative', boxSizing: 'border-box', margin: 'auto' }}>
            <button onClick={() => {
              setSubmissionConfirmOpen(false);
              // Clear form when closing X button
              setTitle('');
              setNote('');
              setTemplate('Official Document / Office Pickup');
              setSensitivity('Sensitive (documents, money, medicine)');
              setPickup('');
              setDropoff('');
              setAgreed(false);
              setPickupTimeSlotDate('');
              setPickupTimeSlotStart('');
              setPickupTimeSlotEnd('');
              setTemplateJustChanged(false);
              if (window.uploadedFilesInput) {
                window.uploadedFilesInput.value = '';
              }
              // Clear cache to prevent restoring old data
              cache.clearFormState();
            }} style={{ position: 'absolute', top: 12, right: 16, background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#888' }}>&times;</button>
            
            {/* Success Icon */}
            <div style={{ fontSize: 64, marginBottom: 16 }}>✅</div>
            
            {/* Status Badge */}
            <div style={{ 
              display: 'inline-block', 
              background: '#dcfce7', 
              color: '#166534', 
              padding: '6px 12px', 
              borderRadius: 6, 
              fontSize: 12, 
              fontWeight: 600, 
              marginBottom: 16,
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              📋 {submittedErrandData.status || 'PENDING'}
            </div>
            
            {/* Title */}
            <h2 style={{ fontWeight: 700, fontSize: 24, marginBottom: 8, color: '#1f2937' }}>Errand Submitted!</h2>
            <p style={{ color: '#666', fontSize: 14, marginBottom: 24, lineHeight: 1.6 }}>
              Your errand has been successfully submitted and is pending verification. You'll receive updates via email.
            </p>
            
            {/* Details Box */}
            <div style={{ 
              background: '#f9fafb', 
              borderRadius: 12, 
              padding: 16, 
              marginBottom: 24,
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Errand Title</div>
                <div style={{ fontSize: 15, fontWeight: 600, color: '#1f2937' }}>{submittedErrandData.title}</div>
              </div>
              <div style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Reference Number</div>
                <div style={{ fontSize: 14, fontWeight: 500, color: '#2563eb', fontFamily: 'monospace' }}>{submittedErrandData.referenceNumber}</div>
              </div>
              {submittedErrandData.pickupTimeSlotDate && (
                <div>
                  <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>📅 Preferred Pickup Time Slot</div>
                  <div style={{ fontSize: 14, fontWeight: 500, color: '#1f2937' }}>
                    {new Date(submittedErrandData.pickupTimeSlotDate).toLocaleDateString()} 
                    {submittedErrandData.pickupTimeSlotStart && ` • ${submittedErrandData.pickupTimeSlotStart}`}
                    {submittedErrandData.pickupTimeSlotEnd && ` - ${submittedErrandData.pickupTimeSlotEnd}`}
                  </div>
                </div>
              )}
            </div>
            
            {/* Info Message */}
            <div style={{ 
              background: '#fef3c7', 
              border: '1px solid #fcd34d',
              borderRadius: 8, 
              padding: 12, 
              marginBottom: 24,
              fontSize: 13,
              color: '#92400e',
              lineHeight: 1.5
            }}>
              📌 <strong>What's next?</strong> Keep your reference number handy. You can track your errand status in the "My Errands" section.
            </div>
            
            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
              <button 
                onClick={() => {
                  setSubmissionConfirmOpen(false);
                  // Clear form - ALL fields
                  setTitle('');
                  setNote('');
                  setTemplate('Official Document / Office Pickup');
                  setSensitivity('Sensitive (documents, money, medicine)');
                  setPickup('');
                  setDropoff('');
                  setAgreed(false);
                  setPickupTimeSlotDate('');
                  setPickupTimeSlotStart('');
                  setPickupTimeSlotEnd('');
                  setTemplateJustChanged(false);
                  if (window.uploadedFilesInput) {
                    window.uploadedFilesInput.value = '';
                  }
                  // Clear cache to prevent restoring old data
                  cache.clearFormState();
                  console.log('[FORM CLEAR] All form fields cleared from Done button');
                }}
                style={{ 
                  flex: 1,
                  maxWidth: 200,
                  background: '#2563eb', 
                  color: '#fff', 
                  border: 'none', 
                  borderRadius: 8, 
                  padding: '12px 16px', 
                  fontWeight: 600, 
                  fontSize: 14, 
                  cursor: 'pointer',
                  transition: 'background 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#1d4ed8'}
                onMouseLeave={(e) => e.currentTarget.style.background = '#2563eb'}
              >
                ✅ Done
              </button>
              <button 
                onClick={() => {
                  setSubmissionConfirmOpen(false);
                  // Optionally scroll to My Errands section
                  const myErrandsSection = document.querySelector('[data-section="my-errands"]');
                  if (myErrandsSection) {
                    myErrandsSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                style={{ 
                  flex: 1,
                  maxWidth: 200,
                  background: '#f3f4f6', 
                  color: '#2563eb', 
                  border: '1.5px solid #2563eb', 
                  borderRadius: 8, 
                  padding: '12px 16px', 
                  fontWeight: 600, 
                  fontSize: 14, 
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#eff6ff';
                  e.currentTarget.style.borderColor = '#1d4ed8';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#f3f4f6';
                  e.currentTarget.style.borderColor = '#2563eb';
                }}
              >
                📊 View My Errands
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ADMIN DASHBOARD MODAL */}
      {adminDashboardOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#0007', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', overflowY: 'auto', paddingTop: 20, paddingBottom: 20, paddingLeft: 10, paddingRight: 10 }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 24, width: '100%', maxWidth: 1400, maxHeight: '90vh', boxShadow: '0 8px 32px #0003', position: 'relative', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
            {/* Close Button */}
            <button onClick={() => setAdminDashboardOpen(false)} style={{ position: 'absolute', top: 12, right: 16, background: 'none', border: 'none', fontSize: 28, cursor: 'pointer', color: '#888', zIndex: 10 }}>&times;</button>
            
            {/* Header */}
            <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 24, color: '#1f2937' }}>👨‍💼 Admin Dashboard</h1>
            
            {/* Tab Navigation */}
            <div style={{ display: 'flex', gap: 8, marginBottom: 24, borderBottom: '1px solid #e5e7eb', paddingBottom: 12, overflowX: 'auto' }}>
              {['customers', 'errands', 'attachments', 'issues', 'stats'].map(tab => (
                <button
                  key={tab}
                  onClick={() => setAdminTab(tab)}
                  style={{
                    padding: '8px 16px',
                    border: 'none',
                    borderBottom: adminTab === tab ? '3px solid #8b5cf6' : 'none',
                    background: 'none',
                    cursor: 'pointer',
                    fontWeight: adminTab === tab ? 600 : 400,
                    color: adminTab === tab ? '#8b5cf6' : '#666',
                    fontSize: 14,
                    transition: 'all 0.2s',
                    whiteSpace: 'nowrap'
                  }}
                  onMouseEnter={(e) => { e.target.style.color = '#8b5cf6'; }}
                  onMouseLeave={(e) => { e.target.style.color = adminTab === tab ? '#8b5cf6' : '#666'; }}
                >
                  {tab === 'customers' && '👥 Customers'}
                  {tab === 'errands' && '📦 Errands'}
                  {tab === 'attachments' && '📎 Attachments'}
                  {tab === 'issues' && '🔍 Issues'}
                  {tab === 'stats' && '📊 Statistics'}
                </button>
              ))}
            </div>

            {/* Content Loading */}
            {adminLoading && (
              <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                <div style={{ fontSize: 24 }}>⏳ Loading...</div>
              </div>
            )}

            {/* CUSTOMERS TAB */}
            {adminTab === 'customers' && !adminLoading && (
              <div style={{ overflowX: 'auto', flex: 1, borderRadius: 8, border: '1px solid #e5e7eb' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, minWidth: '500px' }}>
                  <thead style={{ position: 'sticky', top: 0, zIndex: 5 }}>
                    <tr style={{ background: '#f3f4f6', borderBottom: '2px solid #e5e7eb' }}>
                      <th style={{ padding: '10px', textAlign: 'left', fontWeight: 600, color: '#374151', whiteSpace: 'nowrap', minWidth: '50px' }}>ID</th>
                      <th style={{ padding: '10px', textAlign: 'left', fontWeight: 600, color: '#374151', whiteSpace: 'nowrap', minWidth: '180px' }}>Email</th>
                      <th style={{ padding: '10px', textAlign: 'left', fontWeight: 600, color: '#374151', whiteSpace: 'nowrap', minWidth: '140px' }}>Name</th>
                      <th style={{ padding: '10px', textAlign: 'left', fontWeight: 600, color: '#374151', whiteSpace: 'nowrap', minWidth: '120px' }}>Phone</th>
                      <th style={{ padding: '10px', textAlign: 'left', fontWeight: 600, color: '#374151', whiteSpace: 'nowrap', minWidth: '100px' }}>City</th>
                      <th style={{ padding: '10px', textAlign: 'left', fontWeight: 600, color: '#374151', whiteSpace: 'nowrap', minWidth: '80px' }}>Verified</th>
                    </tr>
                  </thead>
                  <tbody>
                    {adminCustomers.map(cust => (
                      <tr key={cust.id} style={{ borderBottom: '1px solid #e5e7eb', transition: 'background 0.15s' }} onMouseEnter={(e) => e.currentTarget.style.background = '#f9fafb'} onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}>
                        <td style={{ padding: '10px' }}>{cust.id}</td>
                        <td style={{ padding: '10px', fontSize: 12, color: '#666' }}>{cust.email}</td>
                        <td style={{ padding: '10px' }}>{cust.first_name} {cust.last_name}</td>
                        <td style={{ padding: '10px', fontSize: 12 }}>{cust.phone || '—'}</td>
                        <td style={{ padding: '10px', fontSize: 12 }}>{cust.city || '—'}</td>
                        <td style={{ padding: '10px' }}>
                          <span style={{ 
                            display: 'inline-block',
                            padding: '4px 8px',
                            borderRadius: 4,
                            fontSize: 11,
                            fontWeight: 600,
                            background: cust.is_email_verified ? '#dcfce7' : '#fee2e2',
                            color: cust.is_email_verified ? '#166534' : '#991b1b',
                            whiteSpace: 'nowrap'
                          }}>
                            {cust.is_email_verified ? '✓ Yes' : '✗ No'}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {adminCustomers.length === 0 && (
                  <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>No customers found</div>
                )}
              </div>
            )}

            {/* ERRANDS TAB */}
            {adminTab === 'errands' && !adminLoading && (
              <div style={{ flex: 1, overflowY: 'auto', borderRadius: 8, border: '1px solid #e5e7eb', padding: 12 }}>
                {adminErrandsList.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>No errands found</div>
                ) : (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12 }}>
                    {adminErrandsList.map(errand => (
                      <div 
                        key={errand.id} 
                        style={{ 
                          background: '#fff', 
                          border: '1px solid #e5e7eb', 
                          borderRadius: 8, 
                          padding: 12,
                          boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                          transition: 'all 0.15s ease',
                          cursor: 'pointer'
                        }}
                        onClick={() => handleSelectErrandDetail(errand)}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                          e.currentTarget.style.borderColor = '#d1d5db';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
                          e.currentTarget.style.borderColor = '#e5e7eb';
                        }}
                      >
                        {/* Header: Reference and Status */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8, gap: 8 }}>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 2 }}>Ref: {errand.reference_number || `#${errand.id}`}</div>
                            <div style={{ fontSize: 13, fontWeight: 700, color: '#1f2937', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{errand.title}</div>
                          </div>
                          <span style={{ 
                            display: 'inline-block',
                            padding: '3px 8px',
                            borderRadius: 4,
                            fontSize: 10,
                            fontWeight: 600,
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                            background: errand.status === 'pending' ? '#e0e7ff' : 
                                       errand.status === 'assigned' ? '#dbeafe' : 
                                       errand.status === 'picked_up' ? '#fef3c7' :
                                       errand.status === 'delivered' ? '#d1fae5' :
                                       errand.status === 'completed' ? '#dcfce7' : '#fee2e2',
                            color: errand.status === 'pending' ? '#312e81' : 
                                  errand.status === 'assigned' ? '#0c4a6e' : 
                                  errand.status === 'picked_up' ? '#78350f' :
                                  errand.status === 'delivered' ? '#065f46' :
                                  errand.status === 'completed' ? '#166534' : '#991b1b'
                          }}>
                            {errand.status?.substring(0, 8).toUpperCase()}
                          </span>
                        </div>

                        {/* Description */}
                        {errand.description && (
                          <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 8, lineHeight: 1.4, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                            {errand.description}
                          </div>
                        )}

                        {/* Locations - Compact */}
                        <div style={{ marginBottom: 8, fontSize: 11, color: '#6b7280', lineHeight: 1.4 }}>
                          <div><strong>📍</strong> {errand.pickup_location?.substring(0, 25) || '—'}</div>
                          <div><strong>📍</strong> {errand.dropoff_location?.substring(0, 25) || '—'}</div>
                        </div>

                        {/* Timestamps - Compact */}
                        <div style={{ marginBottom: 8, fontSize: 10, color: '#9ca3af', lineHeight: 1.3 }}>
                          <div>{new Date(errand.created_at).toLocaleDateString()}</div>
                        </div>

                        {/* Actions - Compact */}
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                          {(errand.status === 'pending' || errand.status === 'submitted') && (
                            <button 
                              onClick={() => handleAssignErrand(errand.id)} 
                              style={{ 
                                flex: 1,
                                minWidth: '50px',
                                padding: '6px 10px', 
                                fontSize: 11, 
                                background: '#dbeafe', 
                                border: '1px solid #0c4a6e', 
                                borderRadius: 4, 
                                cursor: 'pointer', 
                                fontWeight: 600, 
                                color: '#0c4a6e',
                                transition: 'all 0.15s ease'
                              }}
                              onMouseEnter={(e) => e.target.style.background = '#bfdbfe'}
                              onMouseLeave={(e) => e.target.style.background = '#dbeafe'}
                            >
                              Assign
                            </button>
                          )}
                          {(errand.status === 'assigned' || errand.status === 'approved') && (
                            <>
                              <button 
                                onClick={() => handleApproveErrand(errand.id)} 
                                style={{ 
                                  flex: 1,
                                  minWidth: '45px',
                                  padding: '6px 8px', 
                                  fontSize: 11, 
                                  background: '#dcfce7', 
                                  border: '1px solid #166534', 
                                  borderRadius: 4, 
                                  cursor: 'pointer', 
                                  fontWeight: 600, 
                                  color: '#166534',
                                  transition: 'all 0.15s ease'
                                }}
                                onMouseEnter={(e) => e.target.style.background = '#bbf7d0'}
                                onMouseLeave={(e) => e.target.style.background = '#dcfce7'}
                              >
                                Approve
                              </button>
                              <button 
                                onClick={() => handleCompleteErrand(errand.id)} 
                                style={{ 
                                  flex: 1,
                                  minWidth: '50px',
                                  padding: '6px 8px', 
                                  fontSize: 11, 
                                  background: '#fecaca', 
                                  border: '1px solid #991b1b', 
                                  borderRadius: 4, 
                                  cursor: 'pointer', 
                                  fontWeight: 600, 
                                  color: '#991b1b',
                                  transition: 'all 0.15s ease'
                                }}
                                onMouseEnter={(e) => e.target.style.background = '#fca5a5'}
                                onMouseLeave={(e) => e.target.style.background = '#fecaca'}
                              >
                                Complete
                              </button>
                            </>
                          )}
                          {(errand.status === 'picked_up' || errand.status === 'in_transit') && (
                            <button 
                              onClick={() => handleCompleteErrand(errand.id)} 
                              style={{ 
                                flex: 1,
                                minWidth: '50px',
                                padding: '6px 8px', 
                                fontSize: 11, 
                                background: '#fecaca', 
                                border: '1px solid #991b1b', 
                                borderRadius: 4, 
                                cursor: 'pointer', 
                                fontWeight: 600, 
                                color: '#991b1b',
                                transition: 'all 0.15s ease'
                              }}
                              onMouseEnter={(e) => e.target.style.background = '#fca5a5'}
                              onMouseLeave={(e) => e.target.style.background = '#fecaca'}
                            >
                              Deliver
                            </button>
                          )}
                          {(errand.status === 'completed' || errand.status === 'delivered') && (
                            <div style={{ width: '100%', padding: '6px 8px', textAlign: 'center', fontSize: 11, color: '#166534', fontWeight: 600, background: '#dcfce7', borderRadius: 4 }}>
                              ✓ Complete
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* ATTACHMENTS TAB */}
            {adminTab === 'attachments' && !adminLoading && (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead>
                    <tr style={{ background: '#f3f4f6', borderBottom: '2px solid #e5e7eb' }}>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>ID</th>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Filename</th>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Size</th>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Errand ID</th>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {adminAttachments.map(att => (
                      <tr key={att.id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                        <td style={{ padding: '12px' }}>{att.id}</td>
                        <td style={{ padding: '12px' }}>{att.filename?.substring(0, 30)}</td>
                        <td style={{ padding: '12px', fontSize: 12 }}>{(att.sizeBytes / 1024 / 1024).toFixed(2)} MB</td>
                        <td style={{ padding: '12px' }}>{att.errand_id}</td>
                        <td style={{ padding: '12px', display: 'flex', gap: 6 }}>
                          <button onClick={() => handleReviewAttachment(att.id, 'approve')} style={{ padding: '4px 8px', fontSize: 11, background: '#dcfce7', border: '1px solid #166534', borderRadius: 4, cursor: 'pointer', fontWeight: 600, color: '#166534' }}>
                            ✅
                          </button>
                          <button onClick={() => handleReviewAttachment(att.id, 'reject')} style={{ padding: '4px 8px', fontSize: 11, background: '#fee2e2', border: '1px solid #991b1b', borderRadius: 4, cursor: 'pointer', fontWeight: 600, color: '#991b1b' }}>
                            ✗
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {adminAttachments.length === 0 && (
                  <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>No attachments found</div>
                )}
              </div>
            )}

            {/* ISSUES TAB */}
            {adminTab === 'issues' && !adminLoading && (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead>
                    <tr style={{ background: '#f3f4f6', borderBottom: '2px solid #e5e7eb' }}>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>ID</th>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Type</th>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Description</th>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Status</th>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {adminIssues.map(issue => (
                      <tr key={issue.id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                        <td style={{ padding: '12px' }}>{issue.id}</td>
                        <td style={{ padding: '12px' }}>{issue.type || '—'}</td>
                        <td style={{ padding: '12px', fontSize: 12 }}>{issue.description?.substring(0, 40)}</td>
                        <td style={{ padding: '12px' }}>
                          <span style={{ 
                            display: 'inline-block',
                            padding: '4px 8px',
                            borderRadius: 4,
                            fontSize: 11,
                            fontWeight: 600,
                            background: issue.status === 'open' ? '#fee2e2' : '#dcfce7',
                            color: issue.status === 'open' ? '#991b1b' : '#166534'
                          }}>
                            {issue.status?.toUpperCase()}
                          </span>
                        </td>
                        <td style={{ padding: '12px', display: 'flex', gap: 6 }}>
                          {issue.status === 'open' && (
                            <>
                              <button onClick={() => handleResolveIssue(issue.id, 'resolved')} style={{ padding: '4px 8px', fontSize: 11, background: '#dcfce7', border: '1px solid #166534', borderRadius: 4, cursor: 'pointer', fontWeight: 600, color: '#166534' }}>
                                ✓
                              </button>
                              <button onClick={() => handleResolveIssue(issue.id, 'rejected')} style={{ padding: '4px 8px', fontSize: 11, background: '#fee2e2', border: '1px solid #991b1b', borderRadius: 4, cursor: 'pointer', fontWeight: 600, color: '#991b1b' }}>
                                ✗
                              </button>
                            </>
                          )}
                          {issue.status !== 'open' && (
                            <span style={{ fontSize: 11, color: '#999' }}>—</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {adminIssues.length === 0 && (
                  <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>No issues found</div>
                )}
              </div>
            )}

            {/* STATISTICS TAB */}
            {adminTab === 'stats' && !adminLoading && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
                <div style={{ background: '#f3f4f6', borderRadius: 12, padding: 20, textAlign: 'center' }}>
                  <div style={{ fontSize: 32, fontWeight: 700, color: '#2563eb' }}>{adminStats?.total_users || 0}</div>
                  <div style={{ fontSize: 14, color: '#666', marginTop: 8 }}>Total Users</div>
                </div>
                <div style={{ background: '#f3f4f6', borderRadius: 12, padding: 20, textAlign: 'center' }}>
                  <div style={{ fontSize: 32, fontWeight: 700, color: '#10b981' }}>{adminStats?.verified_users || 0}</div>
                  <div style={{ fontSize: 14, color: '#666', marginTop: 8 }}>Verified Users</div>
                </div>
                <div style={{ background: '#f3f4f6', borderRadius: 12, padding: 20, textAlign: 'center' }}>
                  <div style={{ fontSize: 32, fontWeight: 700, color: '#f59e0b' }}>{adminStats?.pending_issues || 0}</div>
                  <div style={{ fontSize: 14, color: '#666', marginTop: 8 }}>Pending Issues</div>
                </div>
                <div style={{ background: '#f3f4f6', borderRadius: 12, padding: 20, textAlign: 'center' }}>
                  <div style={{ fontSize: 32, fontWeight: 700, color: '#8b5cf6' }}>{adminStats?.total_errands || 0}</div>
                  <div style={{ fontSize: 14, color: '#666', marginTop: 8 }}>Total Errands</div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ERRAND DETAIL MODAL */}
      {selectedErrandDetail && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.6)', zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center', overflowY: 'auto', padding: '20px' }} onClick={() => setSelectedErrandDetail(null)}>
          <div style={{ background: '#fff', borderRadius: 16, padding: '32px', width: '100%', maxWidth: 700, boxShadow: '0 20px 60px rgba(0,0,0,0.3)', position: 'relative', boxSizing: 'border-box' }} onClick={(e) => e.stopPropagation()}>
            {/* Close Button */}
            <button onClick={() => setSelectedErrandDetail(null)} style={{ position: 'absolute', top: 16, right: 16, background: 'none', border: 'none', fontSize: 28, cursor: 'pointer', color: '#999', transition: 'color 0.2s' }} onMouseEnter={(e) => e.target.style.color = '#333'} onMouseLeave={(e) => e.target.style.color = '#999'}>
              ✕
            </button>

            {/* Header */}
            <div style={{ marginBottom: 24, paddingBottom: 16, borderBottom: '2px solid #e5e7eb' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, marginBottom: 8 }}>
                <h2 style={{ fontSize: 24, fontWeight: 700, color: '#1f2937', margin: 0 }}>{selectedErrandDetail.title}</h2>
                <span style={{ 
                  display: 'inline-block',
                  padding: '6px 12px',
                  borderRadius: 6,
                  fontSize: 12,
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                  background: selectedErrandDetail.status === 'pending' ? '#e0e7ff' : 
                             selectedErrandDetail.status === 'submitted' ? '#dbeafe' :
                             selectedErrandDetail.status === 'assigned' ? '#d1fae5' : 
                             selectedErrandDetail.status === 'completed' ? '#dcfce7' : '#fee2e2',
                  color: selectedErrandDetail.status === 'pending' ? '#312e81' : 
                        selectedErrandDetail.status === 'submitted' ? '#0c4a6e' :
                        selectedErrandDetail.status === 'assigned' ? '#065f46' : 
                        selectedErrandDetail.status === 'completed' ? '#166534' : '#991b1b'
                }}>
                  {selectedErrandDetail.status?.toUpperCase()}
                </span>
              </div>
              <p style={{ fontSize: 13, color: '#6b7280', margin: '0 0 8px 0' }}>
                <strong>Ref:</strong> {selectedErrandDetail.reference_number || `#${selectedErrandDetail.id}`}
              </p>
              <p style={{ fontSize: 13, color: '#6b7280', margin: 0 }}>
                <strong>Created:</strong> {new Date(selectedErrandDetail.created_at).toLocaleString()}
              </p>
            </div>

            {/* Description */}
            {selectedErrandDetail.description && (
              <div style={{ marginBottom: 20 }}>
                <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 8, margin: '0 0 8px 0' }}>📝 Description</h3>
                <p style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.6, margin: 0 }}>{selectedErrandDetail.description}</p>
              </div>
            )}

            {/* Locations */}
            <div style={{ marginBottom: 20 }}>
              <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 10, margin: '0 0 10px 0' }}>📍 Locations</h3>
              <div style={{ display: 'grid', gap: 10 }}>
                <div style={{ background: '#f3f4f6', padding: 12, borderRadius: 8, borderLeft: '4px solid #3b82f6' }}>
                  <p style={{ fontSize: 12, fontWeight: 600, color: '#6b7280', margin: '0 0 4px 0', textTransform: 'uppercase' }}>Pickup Location</p>
                  <p style={{ fontSize: 13, color: '#1f2937', margin: 0 }}>{selectedErrandDetail.pickup_location || 'Not specified'}</p>
                </div>
                <div style={{ background: '#f3f4f6', padding: 12, borderRadius: 8, borderLeft: '4px solid #10b981' }}>
                  <p style={{ fontSize: 12, fontWeight: 600, color: '#6b7280', margin: '0 0 4px 0', textTransform: 'uppercase' }}>Dropoff Location</p>
                  <p style={{ fontSize: 13, color: '#1f2937', margin: 0 }}>{selectedErrandDetail.dropoff_location || 'Not specified'}</p>
                </div>
              </div>
            </div>

            {/* Pricing & Distance */}
            <div style={{ marginBottom: 20 }}>
              <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 10, margin: '0 0 10px 0' }}>💰 Pricing & Distance</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                <div style={{ background: '#f3f4f6', padding: 12, borderRadius: 8 }}>
                  <p style={{ fontSize: 12, fontWeight: 600, color: '#6b7280', margin: '0 0 4px 0' }}>Amount</p>
                  <p style={{ fontSize: 16, fontWeight: 700, color: '#059669', margin: 0 }}>₦{selectedErrandDetail.amount ? selectedErrandDetail.amount.toLocaleString() : 'TBD'}</p>
                </div>
                <div style={{ background: '#f3f4f6', padding: 12, borderRadius: 8 }}>
                  <p style={{ fontSize: 12, fontWeight: 600, color: '#6b7280', margin: '0 0 4px 0' }}>Distance</p>
                  <p style={{ fontSize: 16, fontWeight: 700, color: '#0891b2', margin: 0 }}>{selectedErrandDetail.distance_km ? selectedErrandDetail.distance_km + ' km' : 'TBD'}</p>
                </div>
              </div>
            </div>

            {/* Customer Information */}
            <div style={{ marginBottom: 20 }}>
              <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 10, margin: '0 0 10px 0' }}>👤 Customer Information</h3>
              <div style={{ background: '#f9fafb', padding: 14, borderRadius: 8, border: '1px solid #e5e7eb' }}>
                <div style={{ display: 'grid', gap: 10 }}>
                  <div>
                    <p style={{ fontSize: 12, fontWeight: 600, color: '#6b7280', margin: '0 0 4px 0' }}>Name</p>
                    <p style={{ fontSize: 13, color: '#1f2937', margin: 0 }}>{selectedErrandDetail.customer_name || 'Not available'}</p>
                  </div>
                  <div>
                    <p style={{ fontSize: 12, fontWeight: 600, color: '#6b7280', margin: '0 0 4px 0' }}>Contact</p>
                    <p style={{ fontSize: 13, color: '#1f2937', margin: 0 }}>{selectedErrandDetail.customer_phone || 'Not available'}</p>
                  </div>
                  <div>
                    <p style={{ fontSize: 12, fontWeight: 600, color: '#6b7280', margin: '0 0 4px 0' }}>Rating</p>
                    <p style={{ fontSize: 13, color: '#1f2937', margin: 0 }}>⭐ {selectedErrandDetail.customer_rating ? selectedErrandDetail.customer_rating.toFixed(1) : 'New customer'}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Pilot Assignment (if assigned) */}
            {selectedErrandDetail.status === 'assigned' && selectedErrandDetail.assigned_to && (
              <div style={{ marginBottom: 20, background: '#ecfdf5', padding: 14, borderRadius: 8, borderLeft: '4px solid #10b981' }}>
                <h3 style={{ fontSize: 14, fontWeight: 600, color: '#065f46', margin: '0 0 10px 0' }}>✅ Assigned To</h3>
                <div style={{ display: 'grid', gap: 8 }}>
                  <p style={{ fontSize: 13, color: '#047857', margin: 0 }}>
                    <strong>Pilot ID:</strong> {selectedErrandDetail.assigned_to}
                  </p>
                  <p style={{ fontSize: 13, color: '#047857', margin: 0 }}>
                    <strong>Assigned At:</strong> {selectedErrandDetail.assigned_at ? new Date(selectedErrandDetail.assigned_at).toLocaleString() : 'N/A'}
                  </p>
                </div>
              </div>
            )}

            {/* Notes */}
            {selectedErrandDetail.note && (
              <div style={{ marginBottom: 20 }}>
                <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 8, margin: '0 0 8px 0' }}>📌 Notes</h3>
                <p style={{ fontSize: 13, color: '#6b7280', padding: 12, background: '#fef3c7', borderRadius: 8, borderLeft: '4px solid #f59e0b', margin: 0 }}>{selectedErrandDetail.note}</p>
              </div>
            )}

            {/* Attachments Section */}
            {selectedErrandAttachments && selectedErrandAttachments.length > 0 && (
              <div style={{ marginBottom: 20 }}>
                <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 8, margin: '0 0 8px 0' }}>📎 Attachments ({selectedErrandAttachments.length})</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {selectedErrandAttachments.map((attachment) => (
                    <div 
                      key={attachment.id || attachment.original_filename}
                      style={{ 
                        padding: 12, 
                        background: '#eff6ff', 
                        border: '1px solid #bfdbfe', 
                        borderRadius: 6,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <p style={{ margin: '0 0 4px 0', fontSize: 13, fontWeight: 600, color: '#1e40af' }}>
                          📄 {attachment.original_filename || attachment.filename || 'File'}
                        </p>
                        {attachment.size_bytes && (
                          <p style={{ margin: 0, fontSize: 12, color: '#64748b' }}>
                            Size: {(attachment.size_bytes / 1024).toFixed(2)} KB
                          </p>
                        )}
                        {attachment.content_type && (
                          <p style={{ margin: '4px 0 0 0', fontSize: 12, color: '#64748b' }}>
                            Type: {attachment.content_type}
                          </p>
                        )}
                      </div>
                      <button
                        onClick={async () => {
                          try {
                            const token = localStorage.getItem('authToken') || cache.getAuthToken();
                            const response = await fetch(`${API_BASE_URL}/admin/attachments/${attachment.id}/download`, {
                              headers: {
                                'Authorization': `Bearer ${token}`
                              }
                            });
                            if (response.ok) {
                              const blob = await response.blob();
                              const url = window.URL.createObjectURL(blob);
                              const link = document.createElement('a');
                              link.href = url;
                              link.download = attachment.original_filename || 'download';
                              document.body.appendChild(link);
                              link.click();
                              window.URL.revokeObjectURL(url);
                              document.body.removeChild(link);
                            } else {
                              alert('Failed to download file');
                            }
                          } catch (err) {
                            console.error('Download error:', err);
                            alert('Error downloading file');
                          }
                        }}
                        style={{
                          padding: '6px 12px',
                          background: '#3b82f6',
                          color: '#fff',
                          border: 'none',
                          borderRadius: 4,
                          fontSize: 12,
                          fontWeight: 500,
                          cursor: 'pointer',
                          marginLeft: 12,
                          whiteSpace: 'nowrap'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = '#2563eb'}
                        onMouseLeave={(e) => e.currentTarget.style.background = '#3b82f6'}
                      >
                        ⬇️ Download
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: 10, paddingTop: 16, borderTop: '1px solid #e5e7eb', marginTop: 20 }}>
              <button
                onClick={() => setSelectedErrandDetail(null)}
                style={{ 
                  flex: 1,
                  padding: '10px 16px', 
                  fontSize: 14, 
                  background: '#f3f4f6', 
                  border: '1px solid #d1d5db', 
                  borderRadius: 6, 
                  cursor: 'pointer', 
                  fontWeight: 600,
                  color: '#374151',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.background = '#e5e7eb'}
                onMouseLeave={(e) => e.target.style.background = '#f3f4f6'}
              >
                Close
              </button>
              {(selectedErrandDetail.status === 'pending' || selectedErrandDetail.status === 'submitted') && (
                <button
                  onClick={() => {
                    handleAssignErrand(selectedErrandDetail.id);
                    setSelectedErrandDetail(null);
                  }}
                  style={{ 
                    flex: 1,
                    padding: '10px 16px', 
                    fontSize: 14, 
                    background: '#3b82f6', 
                    border: 'none', 
                    borderRadius: 6, 
                    cursor: 'pointer', 
                    fontWeight: 600,
                    color: '#fff',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.background = '#2563eb'}
                  onMouseLeave={(e) => e.target.style.background = '#3b82f6'}
                >
                  Assign Errand
                </button>
              )}
              {(selectedErrandDetail.status === 'assigned' || selectedErrandDetail.status === 'approved') && (
                <>
                  <button
                    onClick={() => {
                      handleApproveErrand(selectedErrandDetail.id);
                      setSelectedErrandDetail(null);
                    }}
                    style={{ 
                      flex: 1,
                      padding: '10px 16px', 
                      fontSize: 14, 
                      background: '#10b981', 
                      border: 'none', 
                      borderRadius: 6, 
                      cursor: 'pointer', 
                      fontWeight: 600,
                      color: '#fff',
                      transition: 'all 0.2s'
                    }}
                    onMouseEnter={(e) => e.target.style.background = '#059669'}
                    onMouseLeave={(e) => e.target.style.background = '#10b981'}
                  >
                    Approve
                  </button>
                  <button
                    onClick={() => {
                      handleCompleteErrand(selectedErrandDetail.id);
                      setSelectedErrandDetail(null);
                    }}
                    style={{ 
                      flex: 1,
                      padding: '10px 16px', 
                      fontSize: 14, 
                      background: '#ef4444', 
                      border: 'none', 
                      borderRadius: 6, 
                      cursor: 'pointer', 
                      fontWeight: 600,
                      color: '#fff',
                      transition: 'all 0.2s'
                    }}
                    onMouseEnter={(e) => e.target.style.background = '#dc2626'}
                    onMouseLeave={(e) => e.target.style.background = '#ef4444'}
                  >
                    Complete
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Settings Modal */}
      <SettingsModal
        open={settingsOpen}
        onClose={() => setSettingsOpen(false)}
        editMode={true}
        setEditMode={() => {}}
        isLoadingProfile={isLoadingProfile}
        editFirstName={editFirstName}
        setEditFirstName={setEditFirstName}
        editLastName={editLastName}
        setEditLastName={setEditLastName}
        editEmail={editEmail}
        setEditEmail={setEditEmail}
        editAddress={editAddress}
        setEditAddress={setEditAddress}
        editCity={editCity}
        setEditCity={setEditCity}
        editCountry={editCountry}
        setEditCountry={setEditCountry}
        editPhone={editPhone}
        setEditPhone={setEditPhone}
        editPostcode={editPostcode}
        setEditPostcode={setEditPostcode}
        notifEnabled={notifEnabled}
        setNotifEnabled={setNotifEnabled}
        handleSaveSettings={handleSaveSettings}
        changePasswordCurrentPassword={changePasswordCurrentPassword}
        setChangePasswordCurrentPassword={setChangePasswordCurrentPassword}
        changePasswordNewPassword={changePasswordNewPassword}
        setChangePasswordNewPassword={setChangePasswordNewPassword}
        changePasswordConfirmPassword={changePasswordConfirmPassword}
        setChangePasswordConfirmPassword={setChangePasswordConfirmPassword}
        handleChangePassword={handleChangePassword}
        changePasswordError={changePasswordError}
        changePasswordSuccess={changePasswordSuccess}
      />
    </div>
  );
}

export default App;
